import Vue from 'vue'
import VueRouter from 'vue-router'
import Weixin from "@/util/weixin";
import Session from '@/util/session';

Vue.use(VueRouter)
/**
 * 说明：需要缓存状态的页面使用keepAlive参数
 * 一般报表、列表可以通过keepAlive而记住查询条件
 */
const routes = [
  {
    path: '/',
    redirect: '/trade'
  },
  {
    /** 登录 */
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/Login.vue'),
    meta: { title: '云系统', auth: false }
  },
  {
    /** APP扫描登录网页版 */
    path: '/qrcode/login',
    name: 'QrcodeLogin',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/QrcodeLogin.vue'),
    meta: { title: '云系统', auth: false }
  },
  {
    /** 注册saas */
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/Register.vue'),
    meta: { title: '云系统', auth: false }
  },
  {
    /** 选择华商云服已绑定企业直接开通saas */
    path: '/auto_register',
    name: 'AutoRegister',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/AutoRegister.vue'),
    meta: { title: '云系统', auth: false }
  },
  {
    path: '/authorize',
    name: 'Authorize',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/Authorize.vue'),
    meta: { title: '云系统', auth: false }
  },
  {
    /** 通过jwt令牌获取身份 */
    path: '/jwt/authorize',
    name: 'JwtAuthorize',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/JwtAuthorize.vue'),
    meta: { title: '云系统', auth: false }
  },
  {
    /** 从统一账户中心跳转鉴别身份 */
    path: '/sso/authorize',
    name: 'SsoAuthorize',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/SsoAuthorize.vue'),
    meta: { title: '云系统', auth: false }
  },
  {
    /** 通过微信公众号接口获取身份 */
    path: '/weixin/authorize',
    name: 'WxAuthorize',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/WxAuthorize.vue'),
    meta: { title: '云系统', auth: false }
  },
  {
    /** 切换身份 */
    path: '/switch_company',
    name: 'SwitchCompany',
    component: () => import(/* webpackChunkName: "security" */ '../views/security/SwitchCompany.vue')
  },
  {
    /** 申请合作伙伴 */
    path: '/apply_partner',
    name: 'ApplyPartner',
    component: () => import(/* webpackChunkName: "partner" */ '../views/qyq/ApplyPartner.vue')
  },
  {
    /** 合作伙伴列表 */
    path: '/partner_list',
    name: 'PartnerList',
    component: () => import(/* webpackChunkName: "partner" */ '../views/qyq/PartnerList.vue')
  },
  {
    /** 合作伙伴 */
    path: '/partner',
    name: 'Partner',
    component: () => import(/* webpackChunkName: "partner" */ '../views/qyq/Partner.vue')
  },
  {
    /** 借h5跳转企业圈小程序端 */
    path: '/launch/qyq',
    name: 'LaunchQyq',
    component: () => import(/* webpackChunkName: "partner" */ '../views/qyq/Launch.vue'),
    meta: { title: '企业圈', auth: false }
  },
  {
    /** 借h5注册并跳转企业圈小程序端 */
    path: '/register/qyq',
    name: 'RegisterQyq',
    component: () => import(/* webpackChunkName: "partner" */ '../views/qyq/Register.vue'),
    meta: { title: '企业圈', auth: false }
  },
  {
    /** 来自纸质名片的推送短信，借h5注册并跳转企业圈小程序端 */
    path: '/business_card/:id',
    name: 'BusinessCard',
    component: () => import(/* webpackChunkName: "partner" */ '../views/qyq/BusinessCard.vue'),
    meta: { title: '企业圈', auth: false }
  },
  {
    /** 错误显示页 */
    path: '/error',
    name: 'Error',
    component: () => import(/* webpackChunkName: "common" */ '../views/common/Error.vue')
  },
  {
    /** 审批实例页 */
    path: '/process/list',
    name: 'ProcessList',
    component: () => import(/* webpackChunkName: "process" */ '../views/process/InstanceTab.vue'),
    meta: { title: '我的审批' }
  },
  {
    /** 审批实例页 */
    path: '/process/instance/:id',
    name: 'ProcessInstance',
    component: () => import(/* webpackChunkName: "process" */ '../views/process/Instance.vue')
  },
  {
    /** 贸易云首页 */
    path: '/trade',
    name: 'Trade',
    component: () => import(/* webpackChunkName: "common" */ '../apps/trade/Index.vue'),
    meta: { title: '贸易云', keepAlive: true },
    children: [{
      path: '',
      component: () => import(/* webpackChunkName: "common" */ '../apps/trade/Home.vue'),
      meta: { title: '贸易云', activeTab: 'home', keepAlive: true }
    }, {
      path: 'b2b',
      component: () => import(/* webpackChunkName: "common" */ '../apps/trade/B2B.vue'),
      meta: { title: 'B2B', activeTab: 'b2b', keepAlive: true }
    }, {
      path: 'process',
      component: () => import(/* webpackChunkName: "common" */ '../views/process/InstanceTab.vue'),
      meta: { title: '我的审批', activeTab: 'process', keepAlive: true }
    }, {
      path: 'report',
      component: () => import(/* webpackChunkName: "common" */ '../apps/trade/ReportTab.vue'),
      meta: { title: '报表', activeTab: 'report', keepAlive: true }
    }, {
      path: 'profile',
      component: () => import(/* webpackChunkName: "common" */ '../apps/trade/ProfileTab.vue'),
      meta: { title: '我', activeTab: 'profile' }
    }]
  },
  {
    /** 制造云首页 */
    path: '/make',
    name: 'Make',
    component: () => import(/* webpackChunkName: "common" */ '../apps/make/Index.vue'),
    meta: { title: '制造云', keepAlive: true },
    children: [{
      path: '',
      component: () => import(/* webpackChunkName: "common" */ '../apps/make/Home.vue'),
      meta: { title: '制造云', activeTab: 'home', keepAlive: true }
    }, {
      path: 'b2b',
      component: () => import(/* webpackChunkName: "common" */ '../apps/make/B2B.vue'),
      meta: { title: 'B2B', activeTab: 'b2b', keepAlive: true }
    }, {
      path: 'process',
      component: () => import(/* webpackChunkName: "common" */ '../views/process/InstanceTab.vue'),
      meta: { title: '我的审批', activeTab: 'process', keepAlive: true }
    }, {
      path: 'report',
      component: () => import(/* webpackChunkName: "common" */ '../apps/make/ReportTab.vue'),
      meta: { title: '报表', activeTab: 'report', keepAlive: true }
    }, {
      path: 'profile',
      component: () => import(/* webpackChunkName: "common" */ '../apps/make/ProfileTab.vue'),
      meta: { title: '我', activeTab: 'profile' }
    }]
  },
  {
    /** 单据分享 */
    path: '/share/:shareId',
    name: 'Share',
    component: () => import(/* webpackChunkName: "common" */ '../views/common/Share.vue'),
    props: (route) => ({ id: route.params.shareId, type: 'share' }),
    meta: { title: '分享', auth: false }
  },
  {
    /** 表单查询 */
    path: '/form/:formId',
    name: 'Form',
    component: () => import(/* webpackChunkName: "common" */ '../views/common/Share.vue'),
    props: (route) => ({ id: route.params.formId, type: 'form' }),
    meta: { title: '表单', auth: false }
  },
  {
    /** 订阅消息 */
    path: '/stat/subscribe',
    name: 'StatSubscribe',
    component: () => import(/* webpackChunkName: "common" */ '../views/stat/Subscribe.vue'),
    meta: { title: '订阅消息', keepAlive: true }
  },
  {
    /** 代理客户报备列表 */
    path: '/agent/clientput_list',
    name: 'AgentClientputList',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/ClientputList.vue'),
    meta: { title: '代理客户报备', keepAlive: true }
  },
  {
    /** 代理客户报备 */
    path: '/agent/clientput',
    name: 'AgentClientput',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/Clientput.vue'),
    meta: { title: '代理客户报备' }
  },
  {
    /** 代理客户拜访列表 */
    path: '/agent/clientvisit_list',
    name: 'AgentClientvisitList',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/ClientvisitList.vue'),
    meta: { title: '代理客户拜访', keepAlive: true }
  },
  {
    /** 代理客户拜访 */
    path: '/agent/clientvisit',
    name: 'AgentClientvisit',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/Clientvisit.vue'),
    meta: { title: '代理客户拜访' }
  },
  {
    /** 客户分配列表 */
    path: '/agent/cust_list',
    name: 'AgentCustList',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/CustList.vue'),
    meta: { title: '客户分配', keepAlive: true }
  },
  {
    /** 客户分配详情页 */
    path: '/agent/cust/:id',
    name: 'AgentCust',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/Cust.vue'),
    meta: { title: '客户分配' }
  },
  {
    /** 客户分配编辑页 */
    path: '/agent/cust_edit',
    name: 'AgentCustEdit',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/CustEdit.vue'),
    meta: { title: '客户分配编辑' }
  },
  {
    /** 编辑代理商变更 */
    path: '/agent/change',
    name: 'AgentChange',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/Change.vue'),
    meta: { title: '编辑代理商变更' }
  },
  {
    /** 客户分配变更详情页 */
    path: '/agent/cust_change/:id',
    name: 'AgentCustChange',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/CustChange.vue'),
    meta: { title: '客户分配变更' }
  },
  {
    /** 代理报价列表 */
    path: '/agent/price_list',
    name: 'AgentPriceList',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/PriceList.vue'),
    meta: { title: '代理报价', keepAlive: true }
  },
  {
    /** 代理报价详情页 */
    path: '/agent/price/:id',
    name: 'AgentPrice',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/Price.vue'),
    meta: { title: '代理报价' }
  },
  {
    /** 代理报价编辑页 */
    path: '/agent/price_edit',
    name: 'AgentPriceEdit',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/PriceEdit.vue'),
    meta: { title: '代理报价编辑' }
  },
  {
    /** 业绩分析列表 */
    path: '/agent/performance_list',
    name: 'AgentPerformanceList',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/PerformanceList.vue'),
    meta: { title: '业绩分析', keepAlive: true }
  },
  {
    /** 业绩分析 */
    path: '/agent/performance',
    name: 'AgentPerformance',
    component: () => import(/* webpackChunkName: "agent" */ '../views/agent/Performance.vue'),
    meta: { title: '业绩分析', }
  },
  {
    /** 销售订单列表 */
    path: '/sale/order_list',
    name: 'SaleOrderList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/OrderList.vue'),
    meta: { title: '销售订单', keepAlive: true }
  },
  {
    /** 销售订单 */
    path: '/sale/order/:id',
    name: 'SaleOrder',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/Order.vue'),
    meta: { title: '销售订单' }
  },
  {
    /** 编辑销售订单 */
    path: '/sale/order_edit',
    name: 'SaleOrderEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/OrderEdit.vue'),
    props: (route) => ({ itemData: route.params.itemData }),
    meta: { title: '编辑销售订单' }
  },
  {
    /** 编辑销售订单变更 */
    path: '/sale/order_change_edit',
    name: 'SaleOrderChangeEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/OrderChangeEdit.vue'),
    props: (route) => ({ itemData: route.params.itemData }),
    meta: { title: '编辑销售订单变更' }
  },
  {
    /** 销售出货列表 */
    path: '/sale/out_list',
    name: 'SaleOutList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/OutList.vue'),
    meta: { title: '销售出货', keepAlive: true }
  },
  {
    /** 销售出货 */
    path: '/sale/out/:id',
    name: 'SaleOut',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/Out.vue'),
    meta: { title: '销售出货' }
  },
  {
    /** 编辑销售出货 */
    path: '/sale/out_edit',
    name: 'SaleOutEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/OutEdit.vue'),
    props: (route) => ({ itemData: route.params.itemData }),
    meta: { title: '编辑销售出货' }
  },
  {
    /** 销售退货列表 */
    path: '/sale/return_list',
    name: 'SaleReturnList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ReturnList.vue'),
    meta: { title: '销售退货', keepAlive: true }
  },
  {
    /** 销售退货 */
    path: '/sale/return/:id',
    name: 'SaleReturn',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/Return.vue'),
    meta: { title: '销售退货' }
  },
  {
    /** 销售计划列表 */
    path: '/sale/planyear_list',
    name: 'PlanYearList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/PlanYearList.vue'),
    meta: { title: '销售计划', keepAlive: true }
  },
  {
    /** 销售计划 */
    path: '/sale/planyear/:id',
    name: 'PlanYear',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/PlanYear.vue'),
    meta: { title: '销售计划' }
  },
  {
    /** 编辑销售计划 */
    path: '/sale/planyear_edit',
    name: 'PlanYearEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/PlanYearEdit.vue'),
    props: (route) => ({ itemData: route.params.itemData }),
    meta: { title: '编辑销售计划' }
  },
  {
    /** 业务员调货单列表 */
    path: '/sale/move_out_seller_list',
    name: 'SaleMoveOutSellerList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/MoveOutSellerList.vue'),
    meta: { title: '业务员调货单', keepAlive: true }
  },
  {
    /** 业务员调货单 */
    path: '/sale/move_out_seller/:id',
    name: 'SaleMoveOutSeller',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/MoveOutSeller.vue'),
    meta: { title: '业务员调货单' }
  },
  {
    /** 编辑业务员调货单 */
    path: '/sale/move_out_seller_edit',
    name: 'SaleMoveOutSellerEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/MoveOutSellerEdit.vue'),
    meta: { title: '编辑业务员调货单' }
  },
  {
    /** 销售备货列表 */
    path: '/sale/forecast_list',
    name: 'SaleForecastList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ForecastList.vue'),
    meta: { title: '销售备货', keepAlive: true }
  },
  {
    /** 销售备货 */
    path: '/sale/forecast/:id',
    name: 'SaleForecast',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/Forecast.vue'),
    meta: { title: '销售备货' }
  },
  {
    /** 编辑销售备货 */
    path: '/sale/forecast_edit',
    name: 'SaleForecastEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ForecastEdit.vue'),
    meta: { title: '编辑销售备货' }
  },
  {
    /** 年度计划分析 */
    path: '/sale/planyear_report',
    name: 'SalePlanYearReport',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/PlanYearReport.vue'),
    meta: { title: '年度计划分析' }
  },
  {
    /** 销售明细表 */
    path: '/sale/order_report',
    name: 'SaleOrderReport',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/OrderReport.vue'),
    meta: { title: '销售订单分析' }
  },
  {
    /** 销售明细表-明细 */
    path: '/sale/order_report_det',
    name: 'SaleOrderReportDetail',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/OrderReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '销售明细表', keepAlive: true }
  },
  {
    /** 销售出货分析 */
    path: '/sale/out_month',
    name: 'SaleOutMonth',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/sale/OutMonth.vue'),
    meta: { title: '销售出货分析' }
  },
  {
    /** 销售出货明细 */
    path: '/sale/sale_out',
    name: 'OutMonth',
    component: () => import(/* webpackChunkName: "sale" */ '../components/OutMonth/SaleOut.vue'),
    meta: { title: '销售出货明细' }
  },
  {
    /** 销售退货分析 */
    path: '/sale/in_month',
    name: 'SaleInMonth',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/sale/InMonth.vue'),
    meta: { title: '销售退货分析' }
  },
  {
    /** 销售出货明细 */
    path: '/sale/sale_in',
    name: 'InMonth',
    component: () => import(/* webpackChunkName: "sale" */ '../components/InMonth/SaleIn.vue'),
    meta: { title: '销售退货明细' }
  },
  {
    /** 销售执行台账 */
    path: '/sale/execute',
    name: 'SaleExecute',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/Execute.vue'),
    meta: { title: '销售执行台账', keepAlive: true }
  },
  {
    /** 销售执行台账详情 */
    path: '/sale/execute_detail',
    name: 'SaleExecuteDetail',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ExecuteDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '销售执行台账详情', keepAlive: true }
  },
  {
    /** 销售出货明细 */
    path: '/sale/out_detail',
    name: 'SaleOutDetail',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/OutDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '销售出货明细' }
  },
  {
    /** 销售预测 */
    path: '/sale/forcast',
    name: 'SaleForcast',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/Forcast.vue'),
    props: (route) => ({ initData: route.params.item, type: route.params.type }),
    meta: { title: '销售预测' }
  },
  {
    /** 网上报价列表 */
    path: '/sale/quote_list',
    name: 'SaleQuoteList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/QuoteList.vue'),
    meta: { title: '网上报价', keepAlive: true }
  },
  {
    /** 网上报价列表 */
    path: '/sale/b2b_inquiry',
    name: 'SaleB2BInquiry',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/QuoteList.vue'),
    meta: { title: '网上报价', keepAlive: true }
  },
  {
    /** 网上报价 */
    path: '/sale/quote/:id',
    name: 'SaleQuote',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/Quote.vue'),
    meta: { title: '网上报价' }
  },
  {
    /** 编辑报价 */
    path: '/sale/quote_edit',
    name: 'SaleQuoteEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/QuoteEdit.vue'),
    meta: { title: '编辑报价' }
  },
  {
    /** 平台商机 */
    path: '/sale/businessChance',
    name: 'SaleBusinessChance',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/BusinessChance.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '平台商机', keepAlive: true }
  },
  {
    /** 样品报价列表 */
    path: '/sale/sample_reply_list',
    name: 'SaleSampleReplyList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/SampleReplyList.vue'),
    meta: { title: '样品报价', keepAlive: true }
  },
  {
    /** 样品报价单 */
    path: '/sale/sample_reply/:id',
    name: 'SaleSampleReply',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/SampleReply.vue'),
    meta: { title: '样品报价单' }
  },
  {
    /** 送样管理列表 */
    path: '/sale/sale_sample_list',
    name: 'SaleSampleList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/SaleSampleList.vue'),
    meta: { title: '送样管理', keepAlive: true }
  },
  {
    /** 送样认证 */
    path: '/sale/sale_sample_edit',
    name: 'SaleSampleEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/SaleSampleEdit.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '送样认证' }
  },
  {
    /** 网上订单列表 */
    path: '/sale/b2b_list',
    name: 'SaleB2BList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/B2BList.vue'),
    meta: { title: '网上订单', keepAlive: true }
  },
  {
    /** b2b采购订单 */
    path: '/sale/b2b_detail_purchase',
    name: 'SaleB2BDetailPurchase',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/B2BDetailPurchase.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b采购订单', keepAlive: true }
  },
  {
    /** b2b采购订单变更 */
    path: '/sale/b2b_detail_purchase_change',
    name: 'SaleB2BDetailPurchaseChange',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/B2BDetailPurchaseChange.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b采购订单变更', keepAlive: true }
  },
  {
    /** b2b外协订单 */
    path: '/sale/b2b_detail_osmake',
    name: 'SaleB2BDetailOsmake',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/B2BDetailOsmake.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b外协订单', keepAlive: true }
  },
  {
    /** b2b外协订单变更 */
    path: '/sale/b2b_detail_osmake_change',
    name: 'SaleB2BDetailOsmakeChange',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/B2BDetailOsmakeChange.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b外协订单变更' }
  },
  {
    /** 交期回复列表 */
    path: '/sale/delivery_reply_list',
    name: 'SaleDeliveryReplyList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/DeliveryReplyList.vue'),
    meta: { title: '交期回复列表', keepAlive: true }
  },
  {
    /** 指定客户的交期回复列表 */
    path: '/sale/cust_delivery_reply',
    name: 'CustDeliveryReplyList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/CustDeliveryReplyList.vue'),
    meta: { title: '交期回复列表', keepAlive: true }
  },
  {
    /** 交期回复 */
    path: '/sale/delivery_reply',
    name: 'SaleDeliveryReply',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/DeliveryReply.vue'),
    meta: { title: '交期回复' }
  },
  {
    /** 发货提醒列表 */
    path: '/sale/shipment_reminder_list',
    name: 'SaleShipmentReminderList',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ShipmentReminderList.vue'),
    meta: { title: '发货提醒列表', keepAlive: true }
  },
  {
    /** 发货提醒 */
    path: '/sale/shipment_reminder',
    name: 'SaleShipmentReminder',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ShipmentReminder.vue'),
    meta: { title: '发货提醒' }
  },
  {
    /** 销售对账单列表按年 */
    path: '/sale/archeck_list_by_year',
    name: 'SaleArcheckListByYear',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ArcheckListByYear.vue'),
    meta: { title: '销售对账单列表', keepAlive: true }
  },
  {
    /** 销售对账单按年 */
    path: '/sale/archeck_by_year',
    name: 'SaleArcheckByYear',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ArcheckByYear.vue'),
    meta: { title: '销售对账单列表' }
  },
  {
    /** 销售对账单按月 */
    path: '/sale/archeck_by_month',
    name: 'SaleArcheckByMonth',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ArcheckByMonth.vue'),
    meta: { title: '销售对账单列表', keepAlive: true }
  },
  {
    /** 销售对账单 */
    path: '/sale/archeck',
    name: 'SaleArcheck',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/Archeck.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '销售对账单', keepAlive: true }
  },
  {
    /** 毛利润分析表 */
    path: '/sale/profit_report',
    name: 'SaleProfitReport',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ProfitReport.vue'),
    meta: { title: '毛利润分析表' }
  },
  {
    /** 毛利润分析表-明细 */
    path: '/sale/profit_report_detail',
    name: 'SaleProfitReportDetail',
    component: () => import(/* webpackChunkName: "sale" */ '../views/sale/ProfitReportDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '毛利润分析表' }
  },
  {
    /** 客户报备列表 */
    path: '/crm/client_put_list',
    name: 'CrmClientPutList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ClientPutList.vue'),
    meta: { title: '客户报备列表', keepAlive: true }
  },
  {
    /** 客户报备 */
    path: '/crm/client_put/:id',
    name: 'CrmClientPut',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ClientPut.vue'),
    meta: { title: '客户报备', }
  },
  {
    /** 编辑客户报备 */
    path: '/crm/client_put_edit/',
    name: 'CrmClientPutEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ClientPutEdit.vue'),
    meta: { title: '编辑客户报备', }
  },
  {
    /** 请购单列表 */
    path: '/purchase/apply_list',
    name: 'PurchaseApplyList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/ApplyList.vue'),
    meta: { title: '请购单', keepAlive: true }
  },
  {
    /** 请购单 */
    path: '/purchase/apply/:id',
    name: 'PurchaseApply',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/Apply.vue'),
    meta: { title: '请购单' }
  },
  {
    /** 编辑请购单 */
    path: '/purchase/apply_edit',
    name: 'PurchaseApplyEdit',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/ApplyEdit.vue'),
    meta: { title: '编辑请购单' }
  },
  {
    /** 请购转采购 */
    path: '/purchase/apply_to_order',
    name: 'PurchaseApplyToOrder',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/ApplyToOrder.vue'),
    meta: { title: '请购转采购' }
  },
  {
    /** 打样申请列表 */
    path: '/purchase/sample_apply_list',
    name: 'PurchaseSampleApplyList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/SampleApplyList.vue'),
    meta: { title: '打样申请', keepAlive: true }
  },
  {
    /** 打样申请单 */
    path: '/purchase/sample_apply/:id',
    name: 'PurchaseSampleApply',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/SampleApply.vue'),
    meta: { title: '打样申请单' }
  },
  {
    /** 采购订单列表 */
    path: '/purchase/order_list',
    name: 'PurchaseOrderList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/OrderList.vue'),
    meta: { title: '采购订单', keepAlive: true }
  },
  {
    /** 采购订单 */
    path: '/purchase/order/:id',
    name: 'PurchaseOrder',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/Order.vue'),
    meta: { title: '采购订单' }
  },
  {
    /** 编辑采购订单 */
    path: '/purchase/order_edit',
    name: 'PurchaseOrderEdit',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/OrderEdit.vue'),
    meta: { title: '编辑采购订单' }
  },
  {
    /** 编辑采购订单变更 */
    path: '/purchase/order_change_edit',
    name: 'PurchaseOrderChangeEdit',
    component: () => import(/* webpackChunkName: "sale" */ '../views/purchase/OrderChangeEdit.vue'),
    props: (route) => ({ itemData: route.params.itemData }),
    meta: { title: '编辑采购订单变更' }
  },
  {
    /** 采购返利明细 */
    path: '/purchase/rebate/:id',
    name: 'PurchaseRebate',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/Rebate.vue'),
    meta: { title: '采购返利明细' }
  },
  {
    /** 采购订单待收货 */
    path: '/purchase/s2s_turn_purc_in',
    name: 'PurchaseS2STurnPurcIn',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/S2STurnPurcIn.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '待收货', keepAlive: true }
  },
  {
    /** 收料单列表 */
    path: '/purchase/verify_apply_list',
    name: 'PurchaseVerifyApplyList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/VerifyApplyList.vue'),
    meta: { title: '收料单', keepAlive: true }
  },
  {
    /** 收料单 */
    path: '/purchase/verify_apply/:id',
    name: 'PurchaseVerifyApply',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/VerifyApply.vue'),
    meta: { title: '收料单' }
  },
  {
    /** 编辑收料单 */
    path: '/purchase/verify_apply_edit',
    name: 'PurchaseVerifyApplyEdit',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/VerifyApplyEdit.vue'),
    meta: { title: '编辑收料单' }
  },
  {
    /** 采购变更单 */
    path: '/purchase/order_change/:id',
    name: 'PurchaseOrderChange',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/OrderChange.vue'),
    meta: { title: '采购变更单' }
  },
  {
    /** 采购入库列表 */
    path: '/purchase/in_list',
    name: 'PurchaseInList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/InList.vue'),
    meta: { title: '采购入库', keepAlive: true }
  },
  {
    /** 采购入库 */
    path: '/purchase/in/:id',
    name: 'PurchaseIn',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/In.vue'),
    meta: { title: '采购入库' }
  },
  {
    /** 编辑采购入库 */
    path: '/purchase/in_edit',
    name: 'PurchaseInEdit',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/InEdit.vue'),
    meta: { title: '编辑采购入库' }
  },
  {
    /** 采购退货列表 */
    path: '/purchase/return_list',
    name: 'PurchaseReturnList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/ReturnList.vue'),
    meta: { title: '采购退货', keepAlive: true }
  },
  {
    /** 采购退货 */
    path: '/purchase/return/:id',
    name: 'PurchaseReturn',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/Return.vue'),
    meta: { title: '采购退货' }
  },
  {
    /** 交期追踪列表 */
    path: '/purchase/delivery_trace_list',
    name: 'PurchaseDeliveryTraceList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/DeliveryTraceList.vue'),
    meta: { title: '交期追踪列表', keepAlive: true }
  },
  {
    /** 交期追踪 */
    path: '/purchase/delivery_trace',
    name: 'PurchaseDeliveryTrace',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/DeliveryTrace.vue'),
    meta: { title: '交期追踪' }
  },
  {
    /** 网上询价列表 */
    path: '/purchase/inquiry_list',
    name: 'PurchaseInquiryList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/InquiryList.vue'),
    meta: { title: '网上询价', keepAlive: true }
  },
  {
    /** 网上询价列表 */
    path: '/purchase/b2b_inquiry',
    name: 'PurchaseB2BInquiry',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/InquiryList.vue'),
    meta: { title: '网上询价', keepAlive: true, filter: { condition: 3 } }
  },
  {
    /** 网上询价 */
    path: '/purchase/inquiry/:id',
    name: 'PurchaseInquiry',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/Inquiry.vue'),
    meta: { title: '网上询价' }
  },
  {
    /** 编辑网上询价 */
    path: '/purchase/inquiry_edit',
    name: 'PurchaseInquiryEdit',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/InquiryEdit.vue'),
    meta: { title: '编辑网上询价' }
  },
  {
    /** 网上询价明细 */
    path: '/purchase/inquiry_detail',
    name: 'PurchaseInquiryDetail',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/InquiryDetail.vue'),
    meta: { title: '网上询价' }
  },
  {
    /** 样品询价列表 */
    path: '/purchase/sample_inquiry_list',
    name: 'PurchaseSampleInquiryList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/SampleInquiryList.vue'),
    meta: { title: '样品询价', keepAlive: true }
  },
  {
    /** 样品询价单 */
    path: '/purchase/sample_inquiry/:id',
    name: 'PurchaseSampleInquiry',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/SampleInquiry.vue'),
    meta: { title: '样品询价单' }
  },
  {
    /** 物料核价列表 */
    path: '/purchase/price_list',
    name: 'PurchasePriceList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/PriceList.vue'),
    meta: { title: '物料核价', keepAlive: true }
  },
  {
    /** 物料核价 */
    path: '/purchase/price/:id',
    name: 'PurchasePrice',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/Price.vue'),
    meta: { title: '物料核价' }
  },
  {
    /** 采购对账单列表按年 */
    path: '/purchase/apcheck_list_by_year',
    name: 'PurchaseApcheckListByYear',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/ApcheckListByYear.vue'),
    meta: { title: '采购对账单列表', keepAlive: true }
  },
  {
    /** 采购对账单按年 */
    path: '/purchase/apcheck_by_year',
    name: 'PurchaseApcheckByYear',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/ApcheckByYear.vue'),
    meta: { title: '采购对账单列表' }
  },
  {
    /** 采购对账单按月 */
    path: '/purchase/apcheck_by_month',
    name: 'PurchaseApcheckByMonth',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/ApcheckByMonth.vue'),
    meta: { title: '采购对账单列表' }
  },
  {
    /** 采购对账单 */
    path: '/purchase/apcheck/:id',
    name: 'PurchaseApcheck',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/Apcheck.vue'),
    meta: { title: '采购对账单', }
  },
  {
    /** 送货通知列表 */
    path: '/purchase/delivery_reminder_list',
    name: 'PurchaseDeliveryReminderList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/DeliveryReminderList.vue'),
    meta: { title: '送货通知列表', keepAlive: true }
  },
  {
    /** 送货通知 */
    path: '/purchase/delivery_reminder',
    name: 'PurchaseDeliveryReminder',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/DeliveryReminder.vue'),
    meta: { title: '送货通知' }
  },
  {
    /** 样品核价列表 */
    path: '/purchase/sample_inquiry_price_list',
    name: 'PurchaseSampleInquiryPriceList',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/SampleInquiryPriceList.vue'),
    meta: { title: '样品核价', keepAlive: true }
  },
  {
    /** 样品核价单 */
    path: '/purchase/sample_inquiry_price/:id',
    name: 'PurchaseSampleInquiryPrice',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/SampleInquiryPrice.vue'),
    meta: { title: '样品核价单' }
  },
  {
    /** 采购订单分析 */
    path: '/purchase/order_report',
    name: 'PurchaseOrderReport',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/OrderReport.vue'),
    meta: { title: '采购订单分析' }
  },
  {
    /** 采购订单分析-明细 */
    path: '/purchase/order_report_det',
    name: 'PurchaseOrderReportDetail',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/OrderReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '采购明细表', keepAlive: true }
  },
  {
    /** 采购入库明细表 */
    path: '/purchase/purchasein_report',
    name: 'PurchasePurchaseinReport',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/PurchaseinReport.vue'),
    meta: { title: '采购入库明细表', keepAlive: true }
  },
  {
    /** 采购入库明细表详情 */
    path: '/purchase/purchasein_report_detail',
    name: 'PurchasePurchaseinReportDetail',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/PurchaseinReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '采购入库明细表详情', keepAlive: true }
  },
  {
    /** 采购执行台账 */
    path: '/purchase/execute',
    name: 'PurchaseExecute',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/Execute.vue'),
    meta: { title: '采购执行台账', keepAlive: true }
  },
  {
    /** 采购执行台账详情 */
    path: '/purchase/execute_detail',
    name: 'PurchaseExecuteDetail',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/ExecuteDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '采购执行台账详情', keepAlive: true }
  },
  {
    /** 盘盈入库列表 */
    path: '/stock/profit_list',
    name: 'StockProfitList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/ProfitList.vue'),
    meta: { title: '盘盈入库', keepAlive: true }
  },
  {
    /** 盘盈入库 */
    path: '/stock/profit/:id',
    name: 'StockProfit',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Profit.vue'),
    meta: { title: '盘盈入库' }
  },
  {
    /** 客供入库列表 */
    path: '/stock/cust_prod_in_list',
    name: 'StockCustProdInList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/CustProdInList.vue'),
    meta: { title: '客供入库', keepAlive: true }
  },
  {
    /** 客供入库 */
    path: '/stock/cust_prod_in/:id',
    name: 'StockCustProdIn',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/CustProdIn.vue'),
    meta: { title: '客供入库' }
  },
  {
    /** 盘亏出库列表 */
    path: '/stock/loss_list',
    name: 'StockLossList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/LossList.vue'),
    meta: { title: '盘亏出库', keepAlive: true }
  },
  {
    /** 盘亏出库 */
    path: '/stock/loss/:id',
    name: 'StockLoss',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Loss.vue'),
    meta: { title: '盘亏出库' }
  },
  {
    /** 其它入库列表 */
    path: '/stock/othin_list',
    name: 'StockOthInList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/OthInList.vue'),
    meta: { title: '其它入库', keepAlive: true }
  },
  {
    /** 其它入库 */
    path: '/stock/othin/:id',
    name: 'StockOthIn',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/OthIn.vue'),
    meta: { title: '其它入库' }
  },
  {
    /** 编辑其它入库 */
    path: '/stock/othin_edit',
    name: 'StockOthInEdit',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/OthInEdit.vue'),
    meta: { title: '编辑其它入库' }
  },
  {
    /** 其它出库列表 */
    path: '/stock/othout_list',
    name: 'StockOthOutList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/OthOutList.vue'),
    meta: { title: '其它出库', keepAlive: true }
  },
  {
    /** 其它出库 */
    path: '/stock/othout/:id',
    name: 'StockOthOut',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/OthOut.vue'),
    meta: { title: '其它出库' }
  },
  {
    /** 编辑其它出库 */
    path: '/stock/othout_edit',
    name: 'StockOthOutEdit',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/OthOutEdit.vue'),
    meta: { title: '编辑其它出库' }
  },
  {
    /** 移仓单列表 */
    path: '/stock/move_list',
    name: 'StockMoveList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/MoveList.vue'),
    meta: { title: '移仓单', keepAlive: true }
  },
  {
    /** 移仓单 */
    path: '/stock/move/:id',
    name: 'StockMove',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Move.vue'),
    meta: { title: '移仓单' }
  },
  {
    /** 编辑移仓单 */
    path: '/stock/move_edit',
    name: 'StockMoveEdit',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/MoveEdit.vue'),
    meta: { title: '编辑移仓单' }
  },
  {
    /** 借货单列表 */
    path: '/stock/goodslend_list',
    name: 'GoodsLendList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/GoodsLendList.vue'),
    meta: { title: '借货单', keepAlive: true }
  },
  {
    /** 借货单 */
    path: '/stock/goodslend/:id',
    name: 'GoodsLend',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/GoodsLend.vue'),
    meta: { title: '借货单' }
  },
  {
    /** 编辑借货单 */
    path: '/stock/goodslend_edit',
    name: 'GoodsLendEdit',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/GoodsLendEdit.vue'),
    meta: { title: '编辑借货单' }
  },
  {
    /** 还货单列表 */
    path: '/stock/goodsback_list',
    name: 'GoodsBackList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/GoodsBackList.vue'),
    meta: { title: '还货单', keepAlive: true }
  },
  {
    /** 还货单 */
    path: '/stock/goodsback/:id',
    name: 'GoodsBack',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/GoodsBack.vue'),
    meta: { title: '还货单' }
  },
  {
    /** 编辑还货单 */
    path: '/stock/goodsback_edit',
    name: 'GoodsBackEdit',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/GoodsBackEdit.vue'),
    meta: { title: '编辑还货单' }
  },
  {
    /** 库存导入列表 */
    path: '/stock/in_list',
    name: 'StockInList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/InList.vue'),
    meta: { title: '库存导入', keepAlive: true }
  },
  {
    /** 库存导入明细 */
    path: '/stock/in/:id',
    name: 'StockIn',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/In.vue'),
    meta: { title: '库存导入明细' }
  },
  {
    /** 编辑库存导入 */
    path: '/stock/in_edit',
    name: 'StockInEdit',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/InEdit.vue'),
    meta: { title: '编辑库存导入' }
  },
  {
    /** 库存导入变更明细 */
    path: '/stock/in_change/:id',
    name: 'StockInChange',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/InChange.vue'),
    meta: { title: '库存导入变更明细' }
  },
  {
    /** 期末调整单列表 */
    path: '/stock/adjust_list',
    name: 'StockAdjustList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/AdjustList.vue'),
    meta: { title: '期末调整单', keepAlive: true }
  },
  {
    /** 期末调整单明细 */
    path: '/stock/adjust/:id',
    name: 'StockAdjust',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Adjust.vue'),
    meta: { title: '期末调整单明细' }
  },
  {
    /** 编辑期末调整单 */
    path: '/stock/adjust_edit',
    name: 'StockAdjustEdit',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/AdjustEdit.vue'),
    meta: { title: '编辑期末调整单' }
  },
  {
    /** 库存明细表 */
    path: '/stock/report',
    name: 'StockReport',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Report.vue'),
    meta: { title: '库存明细表', }
  },
  {
    /** 库存明细表-明细 */
    path: '/stock/report_det',
    name: 'StockReportDetail',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/ReportDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '库存明细表' }
  },
  {
    /** 采购收料列表 */
    path: '/stock/verifyapply_list',
    name: 'PurcVerifyApplyList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/VerifyApplyList.vue'),
    meta: { title: '采购收料', keepAlive: true }
  },
  {
    /** 采购收料 */
    path: '/stock/verifyapply/:id',
    name: 'PurcVerifyApply',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/VerifyApply.vue'),
    meta: { title: '采购收料' }
  },
  {
    /** 客供退料列表 */
    path: '/stock/cust_prod_out_list',
    name: 'StockCustProdOutList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/CustProdOutList.vue'),
    meta: { title: '客供退料', keepAlive: true }
  },
  {
    /** 客供退料 */
    path: '/stock/cust_prod_out/:id',
    name: 'StockCustProdOut',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/CustProdOut.vue'),
    meta: { title: '客供退料' }
  },
  {
    /** 客供收料列表 */
    path: '/stock/customer_receive_list',
    name: 'StockCustomerReceiveList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/CustomerReceiveList.vue'),
    meta: { title: '客供收料', keepAlive: true }
  },
  {
    /** 客供收料 */
    path: '/stock/customer_receive/:id',
    name: 'StockCustomerReceive',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/CustomerReceive.vue'),
    meta: { title: '客供收料' }
  },
  {
    /** 库存收发明细表 */
    path: '/stock/prodiodetail_report',
    name: 'StockProdiodetailReport',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/ProdiodetailReport.vue'),
    meta: { title: '库存收发明细表', keepAlive: true }
  },
  {
    /** 库存收发明细表详情 */
    path: '/stock/prodiodetail_report_detail',
    name: 'StockProdiodetailReportDetail',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/ProdiodetailReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '库存收发明细表详情' }
  },
  {
    /** 库存进销分析 */
    path: '/stock/purcsale',
    name: 'StockPurcsale',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Purcsale.vue'),
    meta: { title: '库存进销分析' }
  },
  {
    /** 库存进销分析详情 */
    path: '/stock/purcsale_detail',
    name: 'StockPurcsaleDetail',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/PurcsaleDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '库存进销分析详情' }
  },
  {
    /** 库存账龄表 */
    path: '/stock/batchage',
    name: 'StockBatchage',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Batchage.vue'),
    meta: { title: '库存账龄表' }
  },
  {
    /** 库存账龄表详情 */
    path: '/stock/batchage_detail',
    name: 'StockBatchageDetail',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/BatchageDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '库存账龄表详情' }
  },
  {
    /** 批次库存明细表 */
    path: '/stock/batchdetail_report',
    name: 'StockBatchdetailReport',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/BatchdetailReport.vue'),
    meta: { title: '批次库存明细表' }
  },
  {
    /** 批次库存明细表详情 */
    path: '/stock/batchdetail_report_detail',
    name: 'StockBatchdetailReportDetail',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/BatchdetailReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '批次库存明细表详情' }
  },
  {
    /** 条码 */
    path: '/stock/barcode/:code',
    name: 'StockBarcode',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Barcode.vue'),
    props: (route) => ({ code: route.params.code }),
    meta: { title: '条码', auth: false }
  },
  {
    /** 条码 */
    path: '/stock/showbar/:code',
    name: 'ThirdBarcode',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/ThirdBarcode.vue'),
    props: (route) => ({ code: route.params.code }),
    meta: { title: '查询结果', auth: false }
  },
  {
    /** IQC检验列表 */
    path: '/qc/iqc_list',
    name: 'PurcIqcList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/IqcList.vue'),
    meta: { title: 'IQC检验', keepAlive: true }
  },
  {
    /** IQC检验 */
    path: '/qc/iqc/:id',
    name: 'PurcIqc',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/Iqc.vue'),
    meta: { title: 'IQC检验' }
  },
  {
    /** IQC检验退货列表 */
    path: '/qc/iqc_return_list',
    name: 'PurcIqcReturnList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/IqcReturnList.vue'),
    meta: { title: '检验退货', keepAlive: true }
  },
  {
    /** IQC检验退货 */
    path: '/qc/iqc_return/:id',
    name: 'PurcIqcReturn',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/IqcReturn.vue'),
    meta: { title: '检验退货' }
  },
  {
    /** F/OQC检验列表 */
    path: '/qc/qa_list',
    name: 'MakeQaList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/QaList.vue'),
    meta: { title: 'F/OQC检验', keepAlive: true }
  },
  {
    /** F/OQC检验 */
    path: '/qc/qa/:id',
    name: 'MakeQa',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/Qa.vue'),
    meta: { title: 'F/OQC检验' }
  },
  {
    /** QC检验列表 */
    path: '/qc/qc_list',
    name: 'MakeQcList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/QcList.vue'),
    meta: { title: 'QC检验', keepAlive: true }
  },
  {
    /** QC检验 */
    path: '/qc/qc/:id',
    name: 'MakeQc',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/Qc.vue'),
    meta: { title: 'QC检验' }
  },
  {
    /** QE检验列表 */
    path: '/qc/qe_list',
    name: 'MakeQeList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/QeList.vue'),
    meta: { title: 'QE检验', keepAlive: true }
  },
  {
    /** QE检验 */
    path: '/qc/qe/:id',
    name: 'MakeQe',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/Qe.vue'),
    meta: { title: 'QE检验' }
  },
  {
    /** 首件检验单列表 */
    path: '/qc/firstqc_list',
    name: 'FirstQcList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/FirstQcList.vue'),
    meta: { title: '首件检验单', keepAlive: true }
  },
  {
    /** 首件检验单 */
    path: '/qc/firstqc/:id',
    name: 'FirstQc',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/FirstQc.vue'),
    meta: { title: '首件检验单' }
  },
  {
    /** IPQC检验单列表 */
    path: '/qc/ipqc_list',
    name: 'IpQcList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/IpQcList.vue'),
    meta: { title: 'IPQC检验单', keepAlive: true }
  },
  {
    /** IPQC检验单 */
    path: '/qc/ipqc/:id',
    name: 'IpQc',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/IpQc.vue'),
    meta: { title: 'IPQC检验单' }
  },
  {
    /** MRB来料风险评估列表 */
    path: '/qc/mrb_list',
    name: 'MrbList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/MrbList.vue'),
    meta: { title: 'MRB来料风险评估', keepAlive: true }
  },
  {
    /** MRB来料风险评估 */
    path: '/qc/mrb/:id',
    name: 'Mrb',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/Mrb.vue'),
    meta: { title: 'MRB来料风险评估' }
  },
  {
    /** 8D改善报告列表 */
    path: '/qc/improvement_report_list',
    name: 'ImprovementReportList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/ImprovementReportList.vue'),
    meta: { title: '8D改善报告', keepAlive: true }
  },
  {
    /** 8D改善报告 */
    path: '/qc/improvement_report/:id',
    name: 'ImprovementReport',
    component: () => import(/* webpackChunkName: "stock" */ '../views/qc/ImprovementReport.vue'),
    meta: { title: '8D改善报告' }
  },
  {
    /** IQC检验设置列表 */
    path: '/quality/iqcset_list',
    name: 'IqcSetList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/IqcSetList.vue'),
    meta: { title: 'IQC检验设置', keepAlive: true }
  },
  {
    /** IQC检验设置 */
    path: '/quality/iqcset/:id',
    name: 'IqcSet',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/IqcSet.vue'),
    meta: { title: 'IQC检验设置' }
  },
  {
    /** 首件检验设置列表 */
    path: '/quality/faiset_list',
    name: 'FaiSetList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/FaiSetList.vue'),
    meta: { title: '首件检验设置', keepAlive: true }
  },
  {
    /** 首件检验设置 */
    path: '/quality/faiset/:id',
    name: 'FaiSet',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/FaiSet.vue'),
    meta: { title: '首件检验设置' }
  },
  {
    /** IPQC检验设置列表 */
    path: '/quality/ipqcset_list',
    name: 'IpqcSetList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/IpqcSetList.vue'),
    meta: { title: 'IPQC检验设置', keepAlive: true }
  },
  {
    /** IPQC检验设置 */
    path: '/quality/ipqcset/:id',
    name: 'IpqcSet',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/IpqcSet.vue'),
    meta: { title: 'IPQC检验设置' }
  },
  {
    /** QC不良设置列表 */
    path: '/quality/qcngset_list',
    name: 'QcngSetList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/QcngSetList.vue'),
    meta: { title: 'QC不良设置', keepAlive: true }
  },
  {
    /** QC不良设置 */
    path: '/quality/qcngset/:id',
    name: 'QcngSet',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/QcngSet.vue'),
    meta: { title: 'QC不良设置' }
  },
  {
    /** F/OQC检验设置列表 */
    path: '/quality/foqcset_list',
    name: 'FoqcSetList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/FoqcSetList.vue'),
    meta: { title: 'F/OQC检验设置', keepAlive: true }
  },
  {
    /** F/OQC检验设置 */
    path: '/quality/foqcset/:id',
    name: 'FoqcSet',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/FoqcSet.vue'),
    meta: { title: 'F/OQC检验设置' }
  },
  {
    /** 抽样标准设置列表 */
    path: '/quality/qcsample_list',
    name: 'QcSampleList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/QcSampleList.vue'),
    meta: { title: '抽样标准设置', keepAlive: true }
  },
  {
    /** 抽样标准设置 */
    path: '/quality/qcsample/:id',
    name: 'QcSample',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/QcSample.vue'),
    meta: { title: '抽样标准设置' }
  },
  {
    /** AQL质量标准设置列表 */
    path: '/quality/qcaql_list',
    name: 'QcAqlList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/QcAqlList.vue'),
    meta: { title: 'AQL质量标准设置', keepAlive: true }
  },
  {
    /** AQL质量标准设置 */
    path: '/quality/qcaql/:id',
    name: 'QcAql',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/QcAql.vue'),
    meta: { title: 'AQL质量标准设置' }
  },
  {
    /** 检验不良代码列表 */
    path: '/quality/qcngcodeset_list',
    name: 'QcNgCodeSetList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/QcNgCodeSetList.vue'),
    meta: { title: '检验不良代码', keepAlive: true }
  },
  {
    /** 检验不良代码 */
    path: '/quality/qcngcodeset/:id',
    name: 'QcNgCodeSet',
    component: () => import(/* webpackChunkName: "stock" */ '../views/quality/QcNgCodeSet.vue'),
    meta: { title: '检验不良代码' }
  },
  {
    /** 其他应收发票列表 */
    path: '/money/otherbillar_list',
    name: 'MoneyOtherbillarList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/OtherbillarList.vue'),
    meta: { title: '其他应收发票', keepAlive: true }
  },
  {
    /** 其他应收发票 */
    path: '/money/otherbillar/:id',
    name: 'MoneyOtherbillar',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/Otherbillar.vue'),
    meta: { title: '其他应收发票', keepAlive: true }
  },
  {
    /** 退款申请单列表 */
    path: '/money/receipt_apply_list',
    name: 'MoneyReceiptApplyList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/ReceiptApplyList.vue'),
    meta: { title: '退款申请单', keepAlive: true }
  },
  {
    /** 退款申请单 */
    path: '/money/receipt_apply/:id',
    name: 'MoneyReceiptApply',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/ReceiptApply.vue'),
    meta: { title: '退款申请单' }
  },
  {
    /** 退款单列表（应收) */
    path: '/money/rec_balance_back_list',
    name: 'RecBalanceBackList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/RecBalanceBackList.vue'),
    meta: { title: '退款单', keepAlive: true }
  },
  {
    /** 退款单 */
    path: '/money/rec_balance_back/:id',
    name: 'RecBalanceBack',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/RecBalanceBack.vue'),
    meta: { title: '退款单' }
  },
  {
    /** 应收票据列表 */
    path: '/money/rec_billar_list',
    name: 'BillARList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillARList.vue'),
    meta: { title: '应收票据', keepAlive: true }
  },
  {
    /** 应收票据 */
    path: '/money/rec_billar/:id',
    name: 'BillAR',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillAR.vue'),
    meta: { title: '应收票据' }
  },
  {
    /** 应收票据异动列表 */
    path: '/money/billar_change_list',
    name: 'BillARChangeList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillARChangeList.vue'),
    meta: { title: '应收票据异动', keepAlive: true }
  },
  {
    /** 应收票据异动 */
    path: '/money/billar_change/:id',
    name: 'BillARChange',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillARChange.vue'),
    meta: { title: '应收票据异动' }
  },
  {
    /** 应付票据列表 */
    path: '/money/pay_billap_list',
    name: 'BillAPList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillAPList.vue'),
    meta: { title: '应付票据', keepAlive: true }
  },
  {
    /** 应付票据 */
    path: '/money/pay_billap/:id',
    name: 'BillAP',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillAP.vue'),
    meta: { title: '应付票据' }
  },
  {
    /** 应付票据异动列表 */
    path: '/money/billap_change_list',
    name: 'BillAPChangeList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillAPChangeList.vue'),
    meta: { title: '应付票据异动', keepAlive: true }
  },
  {
    /** 应付票据异动 */
    path: '/money/billap_change/:id',
    name: 'BillAPChange',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillAPChange.vue'),
    meta: { title: '应付票据异动' }
  },
  {
    /** 退款单列表（应付) */
    path: '/money/pay_balance_back_list',
    name: 'PayBalanceBackList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PayBalanceBackList.vue'),
    meta: { title: '退款单', keepAlive: true }
  },
  {
    /** 退款单 */
    path: '/money/pay_balance_back/:id',
    name: 'PayBalanceBack',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PayBalanceBack.vue'),
    meta: { title: '退款单' }
  },
  {
    /** 收款单列表 */
    path: '/money/receipt_list',
    name: 'MoneyReceiptList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/ReceiptList.vue'),
    meta: { title: '收款单', keepAlive: true }
  },
  {
    /** 收款单 */
    path: '/money/receipt/:id',
    name: 'MoneyReceipt',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/Receipt.vue'),
    meta: { title: '收款单' }
  },
  {
    /** 应收核销单列表 */
    path: '/money/recverify_list',
    name: 'MoneyRecVerifyList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/RecVerifyList.vue'),
    meta: { title: '核销单', keepAlive: true }
  },
  {
    /** 核销单 */
    path: '/money/recverify/:id',
    name: 'MoneyRecVerify',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/RecVerify.vue'),
    meta: { title: '核销单' }
  },
  {
    /** 应收调账单列表 */
    path: '/money/othreceivables_list',
    name: 'MoneyOthreceivablesList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/OthreceivablesList.vue'),
    meta: { title: '应收调账单', keepAlive: true }
  },
  {
    /** 应收调账单 */
    path: '/money/othreceivables/:id',
    name: 'MoneyOthreceivables',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/Othreceivables.vue'),
    meta: { title: '应收调账单', keepAlive: true }
  },
  {
    /** 应收调账单待调账 */
    path: '/money/araccountapply/:id',
    name: 'MoneyAraccountapply',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/Araccountapply.vue'),
    meta: { title: '待调账', keepAlive: true }
  },
  {
    /** 其他应付发票列表 */
    path: '/money/otherbillap_list',
    name: 'MoneyOtherbillapList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/OtherbillapList.vue'),
    meta: { title: '其他应付发票', keepAlive: true }
  },
  {
    /** 其他应付发票 */
    path: '/money/otherbillap/:id',
    name: 'MoneyOtherbillap',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/Otherbillap.vue'),
    meta: { title: '其他应付发票', keepAlive: true }
  },
  {
    /** 付款申请单列表 */
    path: '/money/payapply_list',
    name: 'MoneyPayApplyList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PayApplyList.vue'),
    meta: { title: '付款申请单', keepAlive: true }
  },
  {
    /** 付款申请单 */
    path: '/money/payapply/:id',
    name: 'MoneyPayApply',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PayApply.vue'),
    meta: { title: '付款申请单' }
  },
  {
    /** 付款单列表 */
    path: '/money/payment_list',
    name: 'MoneyPaymentList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PaymentList.vue'),
    meta: { title: '付款单', keepAlive: true }
  },
  {
    /** 付款单 */
    path: '/money/payment/:id',
    name: 'MoneyPayment',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/Payment.vue'),
    meta: { title: '付款单' }
  },
  {
    /** 应付核销单列表 */
    path: '/money/payverify_list',
    name: 'MoneyPayVerifyList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PayVerifyList.vue'),
    meta: { title: '核销单', keepAlive: true }
  },
  {
    /** 核销单 */
    path: '/money/payverify/:id',
    name: 'MoneyPayVerify',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PayVerify.vue'),
    meta: { title: '核销单' }
  },
  {
    /** 应付调帐单列表 */
    path: '/money/othpayables_list',
    name: 'MoneyOthpayablesList',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/OthpayablesList.vue'),
    meta: { title: '应付调帐单', keepAlive: true }
  },
  {
    /** 应付调帐单 */
    path: '/money/othpayables/:id',
    name: 'MoneyOthpayables',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/Othpayables.vue'),
    meta: { title: '应付调帐单' }
  },
  {
    /** 应付调帐单待调账 */
    path: '/money/apaccountapply/:id',
    name: 'MoneyApaccountapply',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/Apaccountapply.vue'),
    meta: { title: '应付调帐单待调账' }
  },
  {
    /** 应收账款分析 */
    path: '/money/receipt_report',
    name: 'MoneyReceiptReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/ReceiptReport.vue'),
    meta: { title: '应收账款分析' }
  },
  {
    /** 应收明细表-明细 */
    path: '/money/receipt_report_det',
    name: 'MoneyReceiptReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/ReceiptReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '应收明细表' }
  },
  {
    /** 应付账款分析 */
    path: '/money/payment_report',
    name: 'MoneyPaymentReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PaymentReport.vue'),
    meta: { title: '应付账款分析' }
  },
  {
    /** 应付明细表-明细 */
    path: '/money/payment_report_det',
    name: 'MoneyPaymentReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PaymentReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '应付明细表' }
  },
  {
    /** 应收账款余额表 */
    path: '/money/totalrecdetail_report',
    name: 'MoneyTotalrecdetailReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/TotalrecdetailReport.vue'),
    meta: { title: '应收账款余额表', keepAlive: true }
  },
  {
    /** 应收账款余额表详情 */
    path: '/money/totalrecdetail_report_detail',
    name: 'MoneyTotalrecdetailReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/TotalrecdetailReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '应收账款余额表详情', keepAlive: true }
  },
  {
    /** 业务员应收余额 */
    path: '/money/totalrecdetailbyseller_report',
    name: 'MoneyTotalrecdetailBySellerReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/TotalrecdetailbysellerReport.vue'),
    meta: { title: '业务员应收余额', keepAlive: true }
  },
  {
    /** 业务员应收余额表详情 */
    path: '/money/totalrecdetailbyseller_report_detail',
    name: 'MoneyTotalrecdetailBySellerReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/TotalrecdetailbysellerReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '业务员应收余额表详情', keepAlive: true }
  },
  {
    /** 应付账款余额表 */
    path: '/money/totalpaydetail_report',
    name: 'MoneyTotalpaydetailReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/TotalpaydetailReport.vue'),
    meta: { title: '应付账款余额表', keepAlive: true }
  },
  {
    /** 应付账款余额表详情 */
    path: '/money/totalpaydetail_report_detail',
    name: 'MoneyTotalpaydetailReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/TotalpaydetailReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '应付账款余额表详情', keepAlive: true }
  },
  {
    /** 应收票据余额表 */
    path: '/money/billar_report',
    name: 'BillarReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillarReport.vue'),
    meta: { title: '应收票据余额表', keepAlive: true }
  },
  {
    /** 应收票据余额表详情 */
    path: '/money/billar_report_detail',
    name: 'BillarReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillarReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '应收票据余额表详情', keepAlive: true }
  },
  {
    /** 应付票据余额表 */
    path: '/money/billap_report',
    name: 'BillapReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillapReport.vue'),
    meta: { title: '应付票据余额表', keepAlive: true }
  },
  {
    /** 应付票据余额表详情 */
    path: '/money/billap_report_detail',
    name: 'BillapReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/BillapReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '应付票据余额表详情', keepAlive: true }
  },
  {
    /** 发出商品分析 */
    path: '/money/sendoutgoodsdetail_report',
    name: 'MoneySendoutgoodsdetailReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/SendoutgoodsdetailReport.vue'),
    meta: { title: '发出商品分析' }
  },
  {
    /** 发出商品分析详情 */
    path: '/money/sendoutgoodsdetail_report_detail',
    name: 'MoneySendoutgoodsdetailReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/SendoutgoodsdetailReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '发出商品分析详情', keepAlive: true }
  },
  {
    /** 应收账龄分析 */
    path: '/money/agingaccountsrec_report',
    name: 'MoneyAgingaccountsrecReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/AgingaccountsrecReport.vue'),
    meta: { title: '应收账龄分析' }
  },
  {
    /** 应收账龄分析详情 */
    path: '/money/agingaccountsrec_report_detail',
    name: 'MoneyAgingaccountsrecReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/AgingaccountsrecReportDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '应收账龄分析详情', keepAlive: true }
  },
  {
    /** 应付暂估分析 */
    path: '/money/paytenestidetail_report',
    name: 'MoneyPaytenestidetailReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PaytenestidetailReport.vue'),
    meta: { title: '应付暂估分析' }
  },
  {
    /** 应付暂估分析详情 */
    path: '/money/paytenestidetail_report_detail',
    name: 'MoneyPaytenestidetailReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/PaytenestidetailReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '应付暂估分析详情', keepAlive: true }
  },
  {
    /** 应付账龄分析 */
    path: '/money/agingaccountspay_report',
    name: 'MoneyAgingaccountspayReport',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/AgingaccountspayReport.vue'),
    meta: { title: '应付账龄分析' }
  },
  {
    /** 应付账龄分析详情 */
    path: '/money/agingaccountspay_report_detail',
    name: 'MoneyAgingaccountspayReportDetail',
    component: () => import(/* webpackChunkName: "money" */ '../views/money/AgingaccountspayReportDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '应付账龄分析详情', keepAlive: true }
  },
  {
    /** 资产负债表 */
    path: '/finance/report_balance',
    name: 'FinanceReportBalance',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/ReportBalance.vue'),
    meta: { title: '资产负债表', keepAlive: true }
  },
  {
    /** 利润表 */
    path: '/finance/report_income',
    name: 'FinanceReportIncome',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/ReportIncome.vue'),
    meta: { title: '利润表' }
  },
  {
    /** 现金流量表 */
    path: '/finance/report_cashflow',
    name: 'FinanceReportCashflow',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/ReportCashflow.vue'),
    meta: { title: '现金流量表' }
  },
  {
    /** 费用汇总表 */
    path: '/finance/report_feestatistics',
    name: 'FinanceReportFeestatistics',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/ReportFeestatistics.vue'),
    meta: { title: '费用汇总表' }
  },
  {
    /** 费用预算分析 */
    path: '/finance/report_feebudget',
    name: 'FinanceReportFeeBudget',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/ReportFeeBudget.vue'),
    meta: { title: '费用预算分析' }
  },
  {
    /** 工作任务列表 */
    path: '/oa/worktask_list',
    name: 'WorkTaskList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/WorkTaskList.vue'),
    meta: { title: '工作任务列表', keepAlive: true }
  },
  {
    /** 工作任务 */
    path: '/oa/worktask/:id',
    name: 'WorkTask',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/WorkTask.vue')
  },
  {
    /** 入职申请列表 */
    path: '/oa/entry_apply_list',
    name: 'OaEntryApplyList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EntryApplyList.vue'),
    meta: { title: '入职申请列表', keepAlive: true }
  },
  {
    /** 入职申请 */
    path: '/oa/entry_apply/:id',
    name: 'OaEntryApply',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EntryApply.vue'),
    meta: { title: '入职申请' }
  },
  {
    /** 请假列表 */
    path: '/oa/vacation_list',
    name: 'OaVacationList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/VacationList.vue'),
    meta: { title: '请假列表', keepAlive: true }
  },
  {
    /** 请假 */
    path: '/oa/vacation/:id',
    name: 'OaVacation',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Vacation.vue'),
    meta: { title: '请假' }
  },
  {
    /** 编辑请假单 */
    path: '/oa/vacation_edit',
    name: 'OaVacationEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/VacationEdit.vue'),
    meta: { title: '请假申请' }
  },
  {
    /** 出差列表 */
    path: '/oa/travel_list',
    name: 'OaTravelList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/TravelList.vue'),
    meta: { title: '出差列表', keepAlive: true }
  },
  {
    /** 出差 */
    path: '/oa/travel/:id',
    name: 'OaTravel',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Travel.vue'),
    meta: { title: '出差' }
  },
  {
    /** 出差申请 */
    path: '/oa/travel_edit',
    name: 'OaTravelEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/TravelEdit.vue'),
    meta: { title: '出差申请' }
  },
  {
    /** 加班列表 */
    path: '/oa/overtime_list',
    name: 'OaOvertimeList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/OvertimeList.vue'),
    meta: { title: '加班列表', keepAlive: true }
  },
  {
    /** 加班 */
    path: '/oa/overtime/:id',
    name: 'OaOvertime',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Overtime.vue'),
    meta: { title: '加班' }
  },
  {
    /** 加班申请 */
    path: '/oa/overtime_edit',
    name: 'OaOvertimeEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/OvertimeEdit.vue'),
    meta: { title: '加班申请' }
  },
  {
    /** 补卡列表 */
    path: '/oa/signcard_list',
    name: 'OaSignCardList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SignCardList.vue'),
    meta: { title: '补卡列表', keepAlive: true }
  },
  {
    /** 补卡 */
    path: '/oa/signcard/:id',
    name: 'OaSignCard',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SignCard.vue'),
    meta: { title: '补卡' }
  },
  {
    /** 补卡申请 */
    path: '/oa/signcard_edit',
    name: 'OaSignCardEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SignCardEdit.vue'),
    meta: { title: '补卡申请' }
  },
  {
    /** 调班列表 */
    path: '/oa/changeclass_list',
    name: 'OaChangeClassList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/ChangeClassList.vue'),
    meta: { title: '调班列表', keepAlive: true }
  },
  {
    /** 调班 */
    path: '/oa/changeclass/:id',
    name: 'OaChangeClass',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/ChangeClass.vue'),
    meta: { title: '调班' }
  },
  {
    /** 调班申请 */
    path: '/oa/changeclass_edit',
    name: 'OaChangeClassEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/ChangeClassEdit.vue'),
    meta: { title: '调班申请' }
  },
  {
    /** 补班列表 */
    path: '/oa/repairclass_list',
    name: 'OaRepairClassList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/RepairClassList.vue'),
    meta: { title: '补班列表', keepAlive: true }
  },
  {
    /** 补班 */
    path: '/oa/repairclass/:id',
    name: 'OaRepairClass',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/RepairClass.vue'),
    meta: { title: '补班' }
  },
  {
    /** 补班申请 */
    path: '/oa/repairclass_edit',
    name: 'OaRepairClassEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/RepairClassEdit.vue'),
    meta: { title: '补班申请' }
  },
  {
    /** 工作报告列表 */
    path: '/oa/workreport_list',
    name: 'OaWorkreportList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/WorkreportList.vue'),
    meta: { title: '工作报告列表', keepAlive: true }
  },
  {
    /** 工作报告详情 */
    path: '/oa/workreport/:id',
    name: 'OaWorkreport',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Workreport.vue'),
    meta: { title: '工作报告详情', keepAlive: true }
  },
  {
    /** 工作报告编辑 */
    path: '/oa/workreport_edit',
    name: 'OaWorkreportEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/WorkreportEdit.vue'),
    meta: { title: '工作报告编辑' }
  },
  {
    /** 会议 */
    path: '/oa/meet',
    name: 'OaMeet',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Meet.vue'),
    meta: { title: '会议', keepAlive: true }
  },

  {
    /** 会议管理列表 */
    path: '/oa/meeting_list',
    name: 'OaMeetingList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/MeetingList.vue'),
    meta: { title: '会议管理列表', keepAlive: true }
  },
  {
    /** 会议管理详情 */
    path: '/oa/meeting/:id',
    name: 'OaMeeting',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Meeting.vue'),
    meta: { title: '会议管理详情', keepAlive: true }
  },
  {
    /** 会议管理编辑 */
    path: '/oa/meeting_edit',
    name: 'OaMeetingEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/MeetingEdit.vue'),
    meta: { title: '会议管理编辑' }
  },
  // {
  //   path: '/personnel_table',
  //   name: 'PersonnelTable',
  //   component: () => import('../views/oa/PersonnelTable.vue'),
  //   meta: { title: '日程表' }
  // },
  // {
  //   path: '/meeting_room',
  //   name: 'MeetingRoom',
  //   component: () => import('../views/oa/MeetingRoom.vue'),
  //   meta: { title: '会议室' }
  // },
  {
    /** 会议模板列表 */
    path: '/oa/meeting_template_list',
    name: 'OaMeetingTemplateList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/MeetingTemplateList.vue'),
    meta: { title: '会议模板列表', keepAlive: true }
  },
  {
    /** 会议模板详情 */
    path: '/oa/meeting_template/:id',
    name: 'OaMeetingTemplate',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/MeetingTemplate.vue'),
    meta: { title: '会议模板详情', keepAlive: true }
  },
  {
    /** 会议模板编辑 */
    path: '/oa/meeting_template_edit',
    name: 'OaMeetingTemplateEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/MeetingTemplateEdit.vue'),
    meta: { title: '会议模板编辑' }
  },
  {
    /** 费用预算列表 */
    path: '/oa/fee_budget_list',
    name: 'OaFeeBudgetList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeBudgetList.vue'),
    meta: { title: '费用预算列表', keepAlive: true }
  },
  {
    /** 费用预算 */
    path: '/oa/fee_budget/:id',
    name: 'OaFeeBudget',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeBudget.vue'),
    meta: { title: '费用预算', keepAlive: true }
  },
  {
    /** 编辑费用预算 */
    path: '/oa/fee_budget_edit',
    name: 'OaFeeBudgetEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeBudgetEdit.vue'),
    meta: { title: '编辑费用预算' }
  },

  {
    /** 费用申请列表 */
    path: '/oa/fee_apply_list',
    name: 'OaFeeApplyList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeApplyList.vue'),
    meta: { title: '费用申请列表', keepAlive: true }
  },
  {
    /** 费用申请列表 */
    path: '/oa/fee_apply/:id',
    name: 'OaFeeApply',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeApply.vue'),
    meta: { title: '费用申请', keepAlive: true }
  },
  {
    /** 编辑费用申请 */
    path: '/oa/fee_apply_edit',
    name: 'OaFeeApplyEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeApplyEdit.vue'),
    meta: { title: '编辑费用申请' }
  },
  {
    /** 编辑费用申请转报销 */
    path: '/oa/fee_apply_turn_edit',
    name: 'OaFeeApplyTurnEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeApplyTurnEdit.vue'),
    meta: { title: '编辑转报销' }
  },
  {
    /** 报销列表 */
    path: '/oa/fee_list',
    name: 'OaFeeList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeList.vue'),
    meta: { title: '报销列表', keepAlive: true }
  },
  {
    /** 报销 */
    path: '/oa/fee/:id',
    name: 'OaFee',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Fee.vue'),
    meta: { title: '报销' }
  },
  {
    /** 报销申请 */
    path: '/oa/fee_edit',
    name: 'OaFeeEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FeeEdit.vue'),
    meta: { title: '报销申请' }
  },
  {
    /** 借款列表 */
    path: '/oa/loan_list',
    name: 'OaLoanList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/LoanList.vue'),
    meta: { title: '借款列表', keepAlive: true }
  },
  {
    /** 借款 */
    path: '/oa/loan/:id',
    name: 'OaLoan',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Loan.vue'),
    meta: { title: '借款' }
  },
  {
    /** 借款申请 */
    path: '/oa/loan_edit',
    name: 'OaLoanEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/LoanEdit.vue'),
    meta: { title: '借款申请' }
  },
  {
    /** 用印列表 */
    path: '/oa/seal_list',
    name: 'OaSealList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SealList.vue'),
    meta: { title: '用印列表', keepAlive: true }
  },
  {
    /** 用印 */
    path: '/oa/seal/:id',
    name: 'OaSeal',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Seal.vue'),
    meta: { title: '用印' }
  },
  {
    /** 用印申请 */
    path: '/oa/seal_edit',
    name: 'OaSealEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SealEdit.vue'),
    meta: { title: '用印申请' }
  },
  {
    /** 用品申请列表 */
    path: '/oa/supplies_apply_list',
    name: 'OaSuppliesApplyList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SuppliesApplyList.vue'),
    meta: { title: '用品申请列表', keepAlive: true }
  },
  {
    /** 用品申请 */
    path: '/oa/supplies_apply/:id',
    name: 'OaSuppliesApply',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SuppliesApply.vue'),
    meta: { title: '用品申请' }
  },
  {
    /** 用品申请编辑 */
    path: '/oa/supplies_apply_edit',
    name: 'OaSuppliesApplyEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SuppliesApplyEdit.vue'),
    meta: { title: '用品申请编辑' }
  },
  {
    /** 人员异动列表 */
    path: '/oa/empchange_list',
    name: 'OaEmpChangeList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EmpChangeList.vue'),
    meta: { title: '人员异动列表', keepAlive: true }
  },
  {
    /** 人员异动 */
    path: '/oa/empchange/:id',
    name: 'OaEmpChange',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EmpChange.vue'),
    meta: { title: '人员异动' }
  },
  {
    /** 人员异动申请 */
    path: '/oa/empchange_edit',
    name: 'OaEmpChangeEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EmpChangeEdit.vue'),
    meta: { title: '人员异动申请' }
  },
  {
    /** 调薪申请列表 */
    path: '/oa/salaryset_change_list',
    name: 'OaSalarysetChangeList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SalarysetChangeList.vue'),
    meta: { title: '调薪申请列表', keepAlive: true }
  },
  {
    /** 调薪申请 */
    path: '/oa/salaryset_change/:id',
    name: 'OaSalarysetChange',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/SalarysetChange.vue'),
    meta: { title: '调薪申请' }
  },
  {
    /** 考勤列表 */
    path: '/oa/attendance_list',
    name: 'OaAttendanceList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/AttendanceList.vue'),
    meta: { title: '考勤列表', keepAlive: true }
  },
  {
    /** 考勤月明细 */
    path: '/oa/attendance/:id',
    name: 'OaAttendance',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Attendance.vue'),
    meta: { title: '考勤月明细' }
  },
  {
    /** 考勤变更明细 */
    path: '/oa/attendance_change/:id',
    name: 'OaAttendanceChange',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/AttendanceChange.vue'),
    meta: { title: '考勤变更明细' }
  },
  {
    /** 考勤日期列表 */
    path: '/oa/attendance_day_list',
    name: 'OaAttendanceDayList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/AttendanceDayList.vue'),
    meta: { title: '考勤日期列表' }
  },
  {
    /** 考勤详细 */
    path: '/oa/attendance_day',
    name: 'OaAttendanceDay',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/AttendanceDay.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '考勤详细' }
  },
  {
    /** 工资列表 */
    path: '/oa/wage_list',
    name: 'OaWageList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/WageList.vue'),
    meta: { title: '工资列表', keepAlive: true }
  },
  {
    /** 工资明细表 */
    path: '/oa/wage/:id',
    name: 'OaWage',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Wage.vue'),
    meta: { title: '工资明细表' }
  },
  {
    /** 招聘列表 */
    path: '/oa/recruit_list',
    name: 'OaRecruitList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/RecruitList.vue'),
    meta: { title: '招聘列表', keepAlive: true }
  },
  {
    /** 招聘 */
    path: '/oa/recruit/:id',
    name: 'OaRecruit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Recruit.vue'),
    meta: { title: '招聘' }
  },
  {
    /** 招聘申请 */
    path: '/oa/recruit_edit',
    name: 'OaRecruitEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/RecruitEdit.vue'),
    meta: { title: '招聘申请' }
  },
  {
    /** 通知列表 */
    path: '/oa/notify_list',
    name: 'OaNotifyList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/NotifyList.vue'),
    meta: { title: '通知列表', keepAlive: true }
  },
  {
    /** 通知 */
    path: '/oa/notify/:id',
    name: 'OaNotify',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Notify.vue'),
    meta: { title: '通知' }
  },
  {
    /** 编辑通知 */
    path: '/oa/notify_edit',
    name: 'OaNotifyEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/NotifyEdit.vue'),
    meta: { title: '发布通知' }
  },
  {
    /** 合同列表 */
    path: '/oa/contract_list',
    name: 'OaContractList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/ContractList.vue'),
    meta: { title: '合同列表', keepAlive: true }
  },
  {
    /** 合同 */
    path: '/oa/contract/:id',
    name: 'OaContract',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Contract.vue'),
    meta: { title: '合同' }
  },
  {
    /** 制度列表 */
    path: '/oa/regulation_list',
    name: 'OaRegulationList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/RegulationList.vue'),
    meta: { title: '公司制度列表', keepAlive: true }
  },
  {
    /** 制度 */
    path: '/oa/regulation/:id',
    name: 'OaRegulation',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Regulation.vue'),
    meta: { title: '公司制度' }
  },
  {
    /** 维保列表 */
    path: '/oa/repair_list',
    name: 'OaRepairList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/RepairList.vue'),
    meta: { title: '维保列表', keepAlive: true }
  },
  {
    /** 维保 */
    path: '/oa/repair/:id',
    name: 'OaRepair',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Repair.vue'),
    meta: { title: '维保' }
  },
  {
    /** 维保申请 */
    path: '/oa/repair_edit',
    name: 'OaRepairEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/RepairEdit.vue'),
    meta: { title: '维保申请' }
  },
  {
    /** 固定资产列表 */
    path: '/oa/fixed_assets_list',
    name: 'OaFixedAssetsList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FixedAssetsList.vue'),
    meta: { title: '固定资产列表', keepAlive: true }
  },
  {
    /** 固定资产 */
    path: '/oa/fixed_assets/:id',
    name: 'OaFixedAssets',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FixedAssets.vue'),
    meta: { title: '固定资产列表' }
  },
  {
    /** 固定资产变更 */
    path: '/oa/fixed_assets_change/:id',
    name: 'OaFixedAssetsChange',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/FixedAssetsChange.vue'),
    meta: { title: '固定资产变更' }
  },
  {
    /** 来访申请（拜访对象使用） */
    path: '/oa/visit_inner_list',
    name: 'OaVisitInnerList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/VisitInnerList.vue'),
    meta: { title: '来访申请', keepAlive: true }
  },
  {
    /** 来访申请（拜访对象使用） */
    path: '/oa/visit_inner/:id',
    name: 'OaVisitInner',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/VisitInner.vue'),
    meta: { title: '来访申请' }
  },
  {
    /** 来访登记二维码（拜访对象使用） */
    path: '/oa/visit_inner_qrcode',
    name: 'OaVisitInnerQrCode',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/VisitInnerQrCode.vue'),
    meta: { title: '来访登记二维码', keepAlive: true }
  },
  {
    /** 来访申请（来访者使用） */
    path: '/oa/visit_inner_visitor/:id',
    name: 'OaVisitInnerVisitor',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/VisitInnerVisitor.vue'),
    meta: { title: '来访申请', auth: false }
  },
  {
    /** 来访申请（来访者使用） */
    path: '/oa/visit_inner_visitor_edit',
    name: 'OaVisitInnerVisitorEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/VisitInnerVisitorEdit.vue'),
    meta: { title: '来访申请', auth: false }
  },
  {
    /** 拜访记录（来访者使用） */
    path: '/oa/visit_inner_visitor_list',
    name: 'OaVisitInnerVisitorList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/VisitInnerVisitorList.vue'),
    meta: { title: '拜访记录', keepAlive: true, auth: false }
  },
  {
    /** 设备列表 */
    path: '/oa/equipment_list',
    name: 'OaEquipmentList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EquipmentList.vue'),
    meta: { title: '设备列表', keepAlive: true }
  },
  {
    /** 设备 */
    path: '/oa/equipment/:id',
    name: 'OaEquipment',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Equipment.vue'),
    meta: { title: '设备' }
  },
  {
    /** 添加设备 */
    path: '/oa/equipment_edit',
    name: 'OaEquipmentEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EquipmentEdit.vue'),
    meta: { title: '添加设备', keepAlive: true }
  },
  {
    /** 设备变更 */
    path: '/oa/equipment_change/:id',
    name: 'OaEquipmentChange',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EquipmentChange.vue'),
    meta: { title: '设备资料变更' }
  },
  {
    /** 点检列表 */
    path: '/oa/equipment_check_list',
    name: 'OaEquipmentCheckList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EquipmentCheckList.vue'),
    meta: { title: '设备列表', keepAlive: true }
  },
  {
    /** 点检 */
    path: '/oa/equipment_check/:id',
    name: 'OaEquipmentCheck',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EquipmentCheck.vue'),
    meta: { title: '设备' }
  },
  {
    /** 添加设备点检 */
    path: '/oa/equipment_check_edit',
    name: 'OaEquipmentCheckEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/EquipmentCheckEdit.vue'),
    meta: { title: '添加设备', keepAlive: true }
  },
  {
    /** 权限申请列表 */
    path: '/oa/auth_apply_list',
    name: 'OaAuthApplyList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/AuthApplyList.vue'),
    meta: { title: '权限申请列表', keepAlive: true }
  },
  {
    /** 权限 */
    path: '/oa/auth_apply/:id',
    name: 'OaAuthApply',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/AuthApply.vue'),
    meta: { title: '权限申请' }
  },
  {
    /** 添加申请权限 */
    path: '/oa/auth_apply_edit',
    name: 'OaAuthApplyEdit',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/AuthApplyEdit.vue'),
    meta: { title: '添加权限申请', keepAlive: true }
  },
  {
    /** 工资条 */
    path: '/oa/salary/:ym',
    name: 'OaSalary',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Salary.vue'),
    meta: { title: '工资条', keepAlive: true }
  },
  {
    /** 考试列表 */
    path: '/oa/exam_list',
    name: 'OaExamList',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/ExamTab.vue'),
    meta: { title: '考试管理', keepAlive: true }
  },
  {
    /** 考试 */
    path: '/oa/exam/:id',
    name: 'OaExam',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/Exam.vue'),
    meta: { title: '考试管理' }
  },
  {
    /** 在线考试 */
    path: '/oa/exam_user/:id',
    name: 'OaExamUser',
    component: () => import(/* webpackChunkName: "oa" */ '../views/oa/ExamUser.vue'),
    meta: { title: '在线考试' }
  },
  {
    /** 仓库列表 */
    path: '/document/warehouse_list',
    name: 'DocumentWarehouseList',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/WarehouseList.vue'),
    meta: { title: '仓库', keepAlive: true }
  },
  {
    /** 仓库 */
    path: '/document/warehouse/:id',
    name: 'DocumentWarehouse',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/Warehouse.vue'),
    meta: { title: '仓库' }
  },
  {
    /** 库存查询 */
    path: '/stock/query_list',
    name: 'StockQueryList',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/QueryList.vue'),
    meta: { title: '库存查询列表' }
  },
  {
    /** 库存详情 */
    path: '/stock/query/:id',
    name: 'StockQuery',
    component: () => import(/* webpackChunkName: "stock" */ '../views/stock/Query.vue'),
    meta: { title: '库存详情' }
  },
  {
    /** 编辑仓库 */
    path: '/document/warehouse_edit',
    name: 'DocumentWarehouseEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/WarehouseEdit.vue'),
    meta: { title: '编辑仓库' }
  },
  {
    /** 产品列表 */
    path: '/document/product_list',
    name: 'DocumentProductList',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/ProductList.vue'),
    meta: { title: '产品资料', keepAlive: true }
  },
  {
    /** 产品 */
    path: '/document/product/:id',
    name: 'DocumentProduct',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/Product.vue'),
    meta: { title: '产品资料' }
  },
  {
    /** 产品 */
    path: '/document/product_change/:id',
    name: 'DocumentProductChange',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/ProductChange.vue'),
    meta: { title: '产品资料变更' }
  },
  {
    /** 编辑产品 */
    path: '/document/product_edit',
    name: 'DocumentProductEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/ProductEdit.vue'),
    meta: { title: '编辑产品资料' }
  },
  {
    /** 客户列表 */
    path: '/document/customer_list',
    name: 'DocumentCustomerList',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CustomerList.vue'),
    meta: { title: '客户', keepAlive: true }
  },
  /** 企业信息 */
  {
    path: '/ent',
    name: 'Enterprise',
    component: () => import(/* webpackChunkName: "document" */ '../views/ent/Enterprise.vue'),
    meta: { title: '企业信息' },
    children: [
      /** 企业经营风险 */
      {
        path: 'Information',
        name: 'Information',
        component: () => import(/* webpackChunkName: "document" */ '../views/ent/Information.vue'),
        meta: { title: '工商信息' }
      },
      /** 企业经营风险 */
      {
        path: 'operatingRisk',
        name: 'OperatingRisk',
        component: () => import(/* webpackChunkName: "document" */ '../views/ent/OperatingRisk.vue'),
        meta: { title: '经营风险' }
      },
      {
        path: 'Litigation',
        name: 'Litigation',
        component: () => import(/* webpackChunkName: "document" */ '../views/ent/Litigation.vue'),
        meta: { title: '法律诉讼' }
      },
    ]
  },
  {
    path: '/ent/operatingRiskDetail',
    name: 'OperatingRiskDetail',
    component: () => import(/* webpackChunkName: "document" */ '../views/ent/OperatingRiskDetail.vue'),
    props: (route) => ({ initData: route.params.items, type: route.params.activeTab }),
    meta: { title: '详情页' }
  },
  {
    path: '/ent/LitigationDetail',
    name: 'LitigationDetail',
    component: () => import(/* webpackChunkName: "document" */ '../views/ent/LitigationDetail.vue'),
    props: (route) => ({ initData: route.params.items, type: route.params.activeTab }),
    meta: { title: '详情页' }
  },
  {
    /** 客户 */
    path: '/document/customer/:id',
    name: 'DocumentCustomer',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/Customer.vue'),
    meta: { title: '客户' }
  },
  {
    /** 客户 */
    path: '/document/customer_change/:id',
    name: 'DocumentCustomerChange',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CustomerChange.vue'),
    meta: { title: '客户变更' }
  },
  {
    /** 编辑客户 */
    path: '/document/customer_edit',
    name: 'DocumentCustomerEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CustomerEdit.vue'),
    meta: { title: '编辑客户' }
  },
  {
    /** 编辑客户变更 */
    path: '/document/customer_change_edit',
    name: 'DocumentCustomerChangeEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CustomerChangeEdit.vue'),
    meta: { title: '编辑客户变更' }
  },
  {
    /** 解挂申请 */
    path: '/document/customer_unlock/:id',
    name: 'DocumentCustomerUnLock',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CustomerUnLock.vue'),
    meta: { title: '解挂申请' }
  },
  {
    /** 解挂申请 */
    path: '/document/customer_unlock_edit',
    name: 'DocumentCustomerUnLockEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CustomerUnLockEdit.vue'),
    meta: { title: '解挂申请' }
  },
  {
    /** 编辑客户临时信用额度 */
    path: '/document/customer_tempcredit_edit',
    name: 'CustomerTempCreditEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CustomerTempCreditEdit.vue'),
    meta: { title: '临时信用额度' }
  },
  {
    /** 客户临时信用额度 */
    path: '/document/customer_tempcredit/:id',
    name: 'CustomerTempCredit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CustomerTempCredit.vue'),
    meta: { title: '临时信用额度' }
  },
  {
    /** 供应商列表 */
    path: '/document/vendor_list',
    name: 'DocumentVendorList',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VendorList.vue'),
    meta: { title: '供应商', keepAlive: true }
  },
  {
    /** 供应商 */
    path: '/document/vendor/:id',
    name: 'DocumentVendor',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/Vendor.vue'),
    meta: { title: '供应商' }
  },
  {
    /** 供应商 */
    path: '/document/vendor_change/:id',
    name: 'DocumentVendorChange',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VendorChange.vue'),
    meta: { title: '供应商变更' }
  },
  {
    /** 编辑供应商 */
    path: '/document/vendor_edit',
    name: 'DocumentVendorEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VendorEdit.vue'),
    meta: { title: '编辑供应商' }
  },
  {
    /** 编辑供应商变更 */
    path: '/document/vendor_change_edit',
    name: 'DocumentVendorChangeEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VendorChangeEdit.vue'),
    meta: { title: '编辑供应商变更' }
  },
  {
    /** 代理列表 */
    path: '/document/agent_list',
    name: 'DocumentAgentList',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/AgentList.vue'),
    meta: { title: '代理', keepAlive: true }
  },
  {
    /** 代理 */
    path: '/document/agent/:id',
    name: 'DocumentAgent',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/Agent.vue'),
    meta: { title: '代理' }
  },
  {
    /** 编辑代理 */
    path: '/document/agent_edit',
    name: 'DocumentAgentEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/AgentEdit.vue'),
    meta: { title: '编辑代理' }
  },
  {
    /** 供应商引进列表 */
    path: '/document/vendor_apply_list',
    name: 'DocumentVendorApplyList',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VendorApplyList.vue'),
    meta: { title: '供应商引进', keepAlive: true }
  },
  {
    /** 供应商引进 */
    path: '/document/vendor_apply/:id',
    name: 'DocumentVendorApply',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VendorApply.vue'),
    meta: { title: '供应商引进' }
  },
  {
    /** 账户列表 */
    path: '/document/account_list',
    name: 'DocumentAccountList',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/AccountList.vue'),
    meta: { title: '账户', keepAlive: true }
  },
  {
    /** 币种列表 */
    path: '/document/currency_list',
    name: 'DocumentCurrencyList',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CurrencyList.vue'),
    meta: { title: '币种', keepAlive: true }
  },
  {
    /** 编辑币种 */
    path: '/document/currency_edit',
    name: 'DocumentCurrencyEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/CurrencyEdit.vue'),
    meta: { title: '编辑币种' }
  },
  {
    /** 币种 */
    path: '/document/currency/:id',
    name: 'DocumentCurrency',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/Currency.vue'),
    meta: { title: '币种' }
  },
  {
    /** 编辑部门 */
    path: '/document/department_edit',
    name: 'DocumentDepartmentEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/DepartmentEdit.vue'),
    meta: { title: '编辑部门' }
  },
  {
    /** 编辑商协通 */
    path: '/document/virtual_org_edit',
    name: 'DocumentVirtualOrgEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VirtualOrgEdit.vue'),
    meta: { title: '编辑商协通' }
  },
  {
    /** 人员信息 */
    path: '/document/employee/:id',
    name: 'DocumentEmployee',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/Employee.vue'),
    meta: { title: '人员信息' }
  },
  {
    /** 商协通人员信息 */
    path: '/document/virtual_employee/:id',
    name: 'DocumentVirtualEmployee',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VirtualEmployee.vue'),
    meta: { title: '人员信息' }
  },
  {
    /** 编辑人员 */
    path: '/document/employee_edit',
    name: 'DocumentEmployeeEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/EmployeeEdit.vue'),
    meta: { title: '编辑人员' }
  },
  {
    /** 编辑个人档案 */
    path: '/document/employee_edit_current',
    name: 'DocumentEmployeeEditCurrent',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/EmployeeEditCurrent.vue'),
    meta: { title: '编辑个人档案' }
  },
  {
    /** 编辑商协通人员 */
    path: '/document/virtual_employee_edit',
    name: 'DocumentVirtualEmployeeEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/document/VirtualEmployeeEdit.vue'),
    meta: { title: '编辑人员' }
  },
  //研发管理
  {
    /** 需求单列表 */
    path: '/plm/demand_list',
    name: 'DemandList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/DemandList.vue'),
    meta: { title: '需求单', keepAlive: true }
  },
  {
    /** 需求单 */
    path: '/plm/demand/:id',
    name: 'Demand',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/Demand.vue'),
    meta: { title: '需求单' }
  },
  {
    /** 编辑需求单 */
    path: '/plm/demand_edit',
    name: 'DemandEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/DemandEdit.vue'),
    meta: { title: '编辑需求单' }
  },
  {
    /** 需求单变更 */
    path: '/plm/demand_change/:id',
    name: 'DemandChange',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/DemandChange.vue'),
    meta: { title: '需求变更单' }
  },

  {
    /** 项目管理列表 */
    path: '/plm/proj_list',
    name: 'ProjList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjList.vue'),
    meta: { title: '项目管理', keepAlive: true }
  },
  {
    /** 项目管理 */
    path: '/plm/proj/:id',
    name: 'Proj',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/Proj.vue'),
    meta: { title: '项目管理' }
  },
  {
    /** 编辑项目管理 */
    path: '/plm/proj_edit',
    name: 'ProjEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjEdit.vue'),
    meta: { title: '编辑项目管理' }
  },
  {
    /** 项目管理变更 */
    path: '/plm/proj_change/:id',
    name: 'ProjChange',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjChange.vue'),
    meta: { title: '项目管理变更单' }
  },
  {
    /** 任务单列表 */
    path: '/plm/proj_task_list',
    name: 'ProjTaskList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjTaskList.vue'),
    meta: { title: '任务单', keepAlive: true }
  },
  {
    /** 任务单 */
    path: '/plm/proj_task/:id',
    name: 'ProjTask',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjTask.vue'),
    meta: { title: '任务单' }
  },
  {
    /** 编辑任务单 */
    path: '/plm/proj_task_edit',
    name: 'ProjTaskEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjTaskEdit.vue'),
    meta: { title: '编辑任务单' }
  },

  {
    /** 阶段验收评审列表 */
    path: '/plm/proj_check_list',
    name: 'ProjCheckList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjCheckList.vue'),
    meta: { title: '阶段验收评审', keepAlive: true }
  },
  {
    /** 阶段验收评审 */
    path: '/plm/proj_check/:id',
    name: 'ProjCheck',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjCheck.vue'),
    meta: { title: '阶段验收评审' }
  },
  {
    /** 编辑阶段验收评审 */
    path: '/plm/proj_check_edit',
    name: 'ProjCheckEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjCheckEdit.vue'),
    meta: { title: '编辑阶段验收评审' }
  },

  {
    /** 问题反馈列表 */
    path: '/plm/problem_feedback_list',
    name: 'ProblemFeedbackList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProblemFeedbackList.vue'),
    meta: { title: '问题反馈', keepAlive: true }
  },
  {
    /** 问题反馈 */
    path: '/plm/problem_feedback/:id',
    name: 'ProblemFeedback',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProblemFeedback.vue'),
    meta: { title: '问题反馈' }
  },
  {
    /** 编辑问题反馈 */
    path: '/plm/problem_feedback_edit',
    name: 'ProblemFeedbackEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProblemFeedbackEdit.vue'),
    meta: { title: '编辑问题反馈' }
  },
  //问题反馈任务单
  {
    /** 问题反馈任务列表 */
    path: '/plm/problem_task_list',
    name: 'ProblemTaskList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProblemTaskList.vue'),
    meta: { title: '问题反馈任务单', keepAlive: true }
  },
  {
    /** 问题反馈任务单 */
    path: '/plm/problem_task/:id',
    name: 'ProblemTask',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProblemTask.vue'),
    meta: { title: '问题反馈任务单' }
  },
  {
    /** 编辑问题反馈任务单*/
    path: '/plm/problem_task_edit',
    name: 'ProblemTaskEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProblemTaskEdit.vue'),
    meta: { title: '编辑问题反馈任务单' }
  },
  {
    /** 市场分析报告列表 */
    path: '/plm/market_report_list',
    name: 'MarketReportList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/MarketReportList.vue'),
    meta: { title: '市场分析报告', keepAlive: true }
  },
  {
    /** 市场分析报告 */
    path: '/plm/market_report/:id',
    name: 'MarketReport',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/MarketReport.vue'),
    meta: { title: '市场分析报告' }
  },
  {
    /** 编辑市场分析报告*/
    path: '/plm/market_report_edit',
    name: 'MarketReportEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/MarketReportEdit.vue'),
    meta: { title: '编辑市场分析报告' }
  },

  {
    /** 技术可行性报告列表 */
    path: '/plm/technical_report_list',
    name: 'TechnicalReportList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/TechnicalReportList.vue'),
    meta: { title: '技术可行性报告', keepAlive: true }
  },
  {
    /** 技术可行性报告 */
    path: '/plm/technical_report/:id',
    name: 'TechnicalReport',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/TechnicalReport.vue'),
    meta: { title: '技术可行性报告' }
  },
  {
    /** 编辑技术可行性报告*/
    path: '/plm/technical_report_edit',
    name: 'TechnicalReportEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/TechnicalReportEdit.vue'),
    meta: { title: '编辑技术可行性报告' }
  },

  {
    /** 成本分析报告列表 */
    path: '/plm/cost_report_list',
    name: 'CostReportList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/CostReportList.vue'),
    meta: { title: '成本分析报告', keepAlive: true }
  },
  {
    /** 成本分析报告 */
    path: '/plm/cost_report/:id',
    name: 'CostReport',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/CostReport.vue'),
    meta: { title: '成本分析报告' }
  },
  {
    /** 编辑成本分析报告*/
    path: '/plm/cost_report_edit',
    name: 'CostReportEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/CostReportEdit.vue'),
    meta: { title: '编辑成本分析报告' }
  },

  {
    /** 研发领料列表 */
    path: '/plm/proj_pick_list',
    name: 'ProjPickList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjPickList.vue'),
    meta: { title: '研发领料', keepAlive: true }
  },
  {
    /** 研发领料 */
    path: '/plm/proj_pick/:id',
    name: 'ProjPick',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjPick.vue'),
    meta: { title: '研发领料' }
  },
  {
    /** 编辑研发领料*/
    path: '/plm/proj_pick_edit',
    name: 'ProjPickEdit',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/ProjPickEdit.vue'),
    meta: { title: '编辑研发领料' }
  },

  {
    /** 供方样品确认列表 */
    path: '/plm/plm_sample_list',
    name: 'PlmSampleList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/PlmSampleList.vue'),
    meta: { title: '供方样品确认', keepAlive: true }
  },
  {
    /** 供方样品确认 */
    path: '/plm/plm_sample/:id',
    name: 'PlmSample',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/PlmSample.vue'),
    meta: { title: '供方样品确认' }
  },

  {
    /** ECR列表 */
    path: '/plm/ecr_list',
    name: 'EcrList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/EcrList.vue'),
    meta: { title: 'ECR', keepAlive: true }
  },
  {
    /** ECR */
    path: '/plm/ecr/:id',
    name: 'Ecr',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/Ecr.vue'),
    meta: { title: 'ECR' }
  },

  {
    /** 研发工单列表 */
    path: '/plm/make_list',
    name: 'PlmMakeList',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/MakeList.vue'),
    meta: { title: '研发工单', keepAlive: true }
  },
  {
    /** 研发工单 */
    path: '/plm/make/:id',
    name: 'PlmMake',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/Make.vue'),
    meta: { title: '研发工单' }
  },

   {
    /** 工时分析报表 */
    path: '/plm/work_hour_report/',
    name: 'WorkHourReport',
    component: () => import(/* webpackChunkName: "plm" */ '../views/plm/WorkHourReport.vue'),
    meta: { title: '工时分析报表' }
  },
  {
    /** 制造工单，兼容消息通知跳转 */
    path: '/make/makebase/:id',
    redirect: '/production/make/:id',
  },
  {
    /** 制造工单 */
    path: '/production/make/:id',
    name: 'ProductionMake',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/Make.vue'),
    meta: { title: '制造工单' }
  },
  {
    /** 制造工单列表 */
    path: '/production/make_list',
    name: 'ProductionMakeList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeList.vue'),
    meta: { title: '制造工单', keepAlive: true }
  },
  {
    /** 制造工单变更 */
    path: '/production/make_change/:id',
    name: 'ProductionMakeChange',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeChange.vue'),
    meta: { title: '制造工单变更' }
  },
  {
    /** 拆解工单列表 */
    path: '/production/disassemble_list',
    name: 'ProductionDisassembleList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/DisassembleList.vue'),
    meta: { title: '拆解工单', keepAlive: true }
  },
  {
    /** 拆解工单 */
    path: '/production/disassemble/:id',
    name: 'ProductionDisassemble',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/Disassemble.vue'),
    meta: { title: '拆解工单' }
  },
  {
    /** 编辑拆解工单 */
    path: '/production/disassemble_edit',
    name: 'ProductionDisassembleEdit',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/DisassembleEdit.vue'),
    meta: { title: '编辑拆解工单' }
  },
  {
    /** 拆解领料明细单列表 */
    path: '/production/disassemble_pick_list',
    name: 'ProductionDisassemblePickList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/DisassemblePickList.vue'),
    meta: { title: '拆解领料明细单', keepAlive: true }
  },
  {
    /** 拆解领料明细单 */
    path: '/production/disassemble_pick/:id',
    name: 'ProductionDisassemblePick',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/DisassemblePick.vue'),
    meta: { title: '拆解领料明细单', keepAlive: true }
  },
  {
    /** 拆解报废明细单列表 */
    path: '/production/disassemble_scrap_list',
    name: 'ProductionDisassembleScrapList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/DisassembleScrapList.vue'),
    meta: { title: '拆解报废明细单', keepAlive: true }
  },
  {
    /** 拆解报废明细单 */
    path: '/production/disassemble_scrap/:id',
    name: 'ProductionDisassembleScrap',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/DisassembleScrap.vue'),
    meta: { title: '拆解报废明细单', keepAlive: true }
  },
  {
    /** 拆解完工入库单列表 */
    path: '/production/disassemble_in_list',
    name: 'ProductionDisassembleInList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/DisassembleInList.vue'),
    meta: { title: '拆解完工入库单', keepAlive: true }
  },
  {
    /** 拆解完工入库单 */
    path: '/production/disassemble_in/:id',
    name: 'ProductionDisassembleIn',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/DisassembleIn.vue'),
    meta: { title: '拆解完工入库单', keepAlive: true }
  },
  {
    /** 生产领料 */
    path: '/production/pick/:id',
    name: 'ProductionPick',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/Pick.vue'),
    meta: { title: '生产领料' }
  },
  {
    /** 生产领料列表 */
    path: '/production/pick_list',
    name: 'ProductionPickList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/PickList.vue'),
    meta: { title: '生产领料', keepAlive: true }
  },
  {
    /** 无定量辅料领料列表 */
    path: '/production/auxiliary_pick_list',
    name: 'ProductionAuxiliaryPickList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/AuxiliaryPickList.vue'),
    meta: { title: '无定量辅料领料', keepAlive: true }
  },
  {
    /** 无定量辅料领料 */
    path: '/production/auxiliary_pick/:id',
    name: 'ProductionAuxiliaryPick',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/AuxiliaryPick.vue'),
    meta: { title: '无定量辅料领料', keepAlive: true }
  },
  {
    /** 生产退料 */
    path: '/production/return/:id',
    name: 'ProductionReturn',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/Return.vue'),
    meta: { title: '生产退料' }
  },
  {
    /** 生产退料列表 */
    path: '/production/return_list',
    name: 'ProductionReturnList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/ReturnList.vue'),
    meta: { title: '生产退料', keepAlive: true }
  },
  {
    /** 生产报废 */
    path: '/production/scrap/:id',
    name: 'ProductionScrap',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/Scrap.vue'),
    meta: { title: '生产报废' }
  },
  {
    /** 生产报废列表 */
    path: '/production/scrap_list',
    name: 'ProductionScrapList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/ScrapList.vue'),
    meta: { title: '生产报废', keepAlive: true }
  },
  {
    /** 生产挪料 */
    path: '/production/relocation/:id',
    name: 'ProductionRelocation',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/Relocation.vue'),
    meta: { title: '生产挪料' }
  },
  {
    /** 生产挪料列表 */
    path: '/production/relocation_list',
    name: 'ProductionRelocationList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/RelocationList.vue'),
    meta: { title: '生产挪料', keepAlive: true }
  },
  {
    /** 完工入库 */
    path: '/production/in/:id',
    name: 'ProductionIn',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/In.vue'),
    meta: { title: '完工入库' }
  },
  {
    /** 完工入库列表 */
    path: '/production/in_list',
    name: 'ProductionInList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/InList.vue'),
    meta: { title: '完工入库', keepAlive: true }
  },
  {
    /** BOM */
    path: '/production/bom/:id',
    name: 'ProductionBom',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/Bom.vue'),
    meta: { title: 'BOM' }
  },
  {
    /** BOM列表 */
    path: '/production/bom_list',
    name: 'ProductionBomList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/BomList.vue'),
    meta: { title: 'BOM', keepAlive: true }
  },
  {
    /** BOM变更 */
    path: '/production/bom_change/:id',
    name: 'ProductionBomChange',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/BomChange.vue'),
    meta: { title: 'BOM变更' }
  },
  {
    /** 物料综合查询列表 */
    path: '/production/bom_composite_list',
    name: 'ProductionBomCompositeList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/BomCompositeList.vue'),
    meta: { title: '物料综合查询', keepAlive: true }
  },
  {
    /** 物料综合信息 */
    path: '/production/bom_composite/:id',
    name: 'ProductionBomComposite',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/BomComposite.vue'),
    meta: { title: '物料综合信息' }
  },
  {
    /** 维修单列表 */
    path: '/production/make_repair_list',
    name: 'MakeRepairList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeRepairList.vue'),
    meta: { title: '维修单' }
  },
  {
    /** 编辑维修单 */
    path: '/production/make_repair_edit',
    name: 'MakeRepairEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/production/MakeRepairEdit.vue'),
    meta: { title: '编辑维修单' }
  },
  {
    /** 维修单 */
    path: '/production/make_repair/:id',
    name: 'MakeRepair',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeRepair.vue'),
    meta: { title: '维修单' }
  },
  {
    /** 分切工单列表 */
    path: '/production/make_cut_list',
    name: 'MakeCutList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutList.vue'),
    meta: { title: '分切工单' }
  },
  {
    /** 分切工单 */
    path: '/production/make_cut/:id',
    name: 'MakeCut',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCut.vue'),
    meta: { title: '分切工单' }
  },
  {
    /** 分切领料明细列表 */
    path: '/production/make_cut_pick_list',
    name: 'MakeCutPickList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutPickList.vue'),
    meta: { title: '分切领料明细' }
  },
  {
    /** 分切领料明细 */
    path: '/production/make_cut_pick/:id',
    name: 'MakeCutPick',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutPick.vue'),
    meta: { title: '分切领料明细' }
  },
  {
    /** 分切退料明细列表 */
    path: '/production/make_cut_return_list',
    name: 'MakeCutReturnList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutReturnList.vue'),
    meta: { title: '分切退料明细' }
  },
  {
    /** 分切退料明细 */
    path: '/production/make_cut_return/:id',
    name: 'MakeCutReturn',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutReturn.vue'),
    meta: { title: '分切退料明细' }
  },
  {
    /** 分切报废明细列表 */
    path: '/production/make_cut_scrap_list',
    name: 'MakeCutScrapList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutScrapList.vue'),
    meta: { title: '分切报废明细' }
  },
  {
    /** 分切报废明细 */
    path: '/production/make_cut_scrap/:id',
    name: 'MakeCutScrap',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutScrap.vue'),
    meta: { title: '分切报废明细' }
  },
  {
    /** 分切完工入库列表 */
    path: '/production/make_cut_in_list',
    name: 'MakeCutInList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutInList.vue'),
    meta: { title: '分切完工入库明细' }
  },
  {
    /** 分切完工入库明细 */
    path: '/production/make_cut_in/:id',
    name: 'MakeCutIn',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeCutIn.vue'),
    meta: { title: '分切完工入库明细' }
  },
  {
    /** 模具管理列表 */
    path: '/production/make_mold_list',
    name: 'MakeMoldList',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeMoldList.vue'),
    meta: { title: '模具管理明细' }
  },
  {
    /** 模具管理明细 */
    path: '/production/make_mold/:id',
    name: 'MakeMold',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeMold.vue'),
    meta: { title: '模具管理明细' }
  },
  {
    /** 编辑模具 */
    path: '/production/make_mold_edit',
    name: 'MakeMoldEdit',
    component: () => import(/* webpackChunkName: "document" */ '../views/production/MakeMoldEdit.vue'),
    meta: { title: '编辑模具' }
  },
  {
    /** 生产日报表 */
    path: '/production/make_hour_report',
    name: 'ProductionMakeHourReport',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeHourReport.vue'),
    meta: { title: '生产日报表' }
  },
  {
    /** 生产日报表 */
    path: '/production/make_hour_report_detail',
    name: 'ProductionMakeHourReportDetail',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeHourReportDetail.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '生产日报表', keepAlive: true }
  },
  {
    /** 工单在制汇总表 */
    path: '/production/make_report',
    name: 'ProductionMakeReport',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/MakeReport.vue'),
    meta: { title: '工单在制汇总表' }
  },
  {
    /** 生产进度跟进表 */
    path: '/production/schedule_report',
    name: 'ProductionScheduleReport',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/ScheduleReport.vue'),
    meta: { title: '生产进度跟进表' }
  },
  {
    /** 生产损耗统计表 */
    path: '/production/loss_report',
    name: 'ProductionLossReport',
    component: () => import(/* webpackChunkName: "production" */ '../views/production/LossReport.vue'),
    meta: { title: '生产损耗统计表' }
  },
  {
    /** 外协工单 */
    path: '/out_prod/make/:id',
    name: 'OutProductionMake',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/Make.vue'),
    meta: { title: '外协工单' }
  },
  {
    /** 外协工单列表 */
    path: '/out_prod/make_list',
    name: 'OutProductionMakeList',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/MakeList.vue'),
    meta: { title: '外协工单', keepAlive: true }
  },
  {
    /** 外协工单待收货 */
    path: '/out_prod/s2s_turn_os_make_in',
    name: 'OutProductionS2STurnOsMakeIn',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/S2STurnOsMakeIn.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '待收货', keepAlive: true }
  },
  {
    /** 外协领料 */
    path: '/out_prod/pick/:id',
    name: 'OutProductionPick',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/Pick.vue'),
    meta: { title: '外协领料' }
  },
  {
    /** 外协领料列表 */
    path: '/out_prod/pick_list',
    name: 'OutProductionPickList',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/PickList.vue'),
    meta: { title: '外协领料', keepAlive: true }
  },
  {
    /** 外协退料 */
    path: '/out_prod/return/:id',
    name: 'OutProductionReturn',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/Return.vue'),
    meta: { title: '外协退料' }
  },
  {
    /** 外协退料列表 */
    path: '/out_prod/return_list',
    name: 'OutProductionReturnList',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/ReturnList.vue'),
    meta: { title: '外协退料', keepAlive: true }
  },
  {
    /** 外协报废 */
    path: '/out_prod/scrap/:id',
    name: 'OutProductionScrap',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/Scrap.vue'),
    meta: { title: '外协报废' }
  },
  {
    /** 外协报废列表 */
    path: '/out_prod/scrap_list',
    name: 'OutProductionScrapList',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/ScrapList.vue'),
    meta: { title: '外协报废', keepAlive: true }
  },
  {
    /** 外协挪料 */
    path: '/out_prod/relocation/:id',
    name: 'OutProductionRelocation',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/Relocation.vue'),
    meta: { title: '外协挪料' }
  },
  {
    /** 外协挪料列表 */
    path: '/out_prod/relocation_list',
    name: 'OutProductionRelocationList',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/RelocationList.vue'),
    meta: { title: '外协挪料', keepAlive: true }
  },
  {
    /** 完工入库 */
    path: '/out_prod/in/:id',
    name: 'OutProductionIn',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/In.vue'),
    meta: { title: '完工入库' }
  },
  {
    /** 完工入库列表 */
    path: '/out_prod/in_list',
    name: 'OutProductionInList',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/InList.vue'),
    meta: { title: '完工入库', keepAlive: true }
  },
  {
    /** 外协退货 */
    path: '/out_prod/out/:id',
    name: 'OutProductionOut',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/Out.vue'),
    meta: { title: '外协退货' }
  },
  {
    /** 外协退货列表 */
    path: '/out_prod/out_list',
    name: 'OutProductionOutList',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/OutList.vue'),
    meta: { title: '外协退货', keepAlive: true }
  },
  {
    /** 外协在制汇总表 */
    path: '/out_prod/make_report',
    name: 'OutProductionMakeReport',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/MakeReport.vue'),
    meta: { title: '外协在制汇总表' }
  },
  {
    /** 外协进度跟进表 */
    path: '/out_prod/schedule_report',
    name: 'OutProductionScheduleReport',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/ScheduleReport.vue'),
    meta: { title: '外协进度跟进表' }
  },
  {
    /** 外协损耗统计表 */
    path: '/out_prod/loss_report',
    name: 'OutProductionLossReport',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/LossReport.vue'),
    meta: { title: '外协损耗统计表' }
  },
  // {
  //   /** 制造工单执行表 */
  //   path: '/out_prod/makedaily_report',
  //   name: 'OutProductionMakedailyReport',
  //   component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/MakedailyReport.vue'),
  //   meta: { title: '制造工单执行表', keepAlive: true }
  // },
  // {
  //   /** 制造工单执行表明细 */
  //   path: '/out_prod/makedaily_report_detail',
  //   name: 'OutProductionMakedailyReportDetail',
  //   component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/MakedailyReportDetail.vue'),
  //   props: (route) => ({ initData: route.params.item }),
  //   meta: { title: '制造工单执行表明细', keepAlive: true }
  // },
  // {
  //   /** 外协工单执行表 */
  //   path: '/out_prod/osmake_execute_report',
  //   name: 'OutProductionOsmakeExecuteReport',
  //   component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/OsmakeExecuteReport.vue'),
  //   meta: { title: '外协工单执行表', keepAlive: true }
  // },
  // {
  //   /** 外协工单执行表明细 */
  //   path: '/out_prod/osmake_execute_report_detail',
  //   name: 'OutProductionOsmakeExecuteReportDetail',
  //   component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/OsmakeExecuteReportDetail.vue'),
  //   props: (route) => ({ initData: route.params.item }),
  //   meta: { title: '外协工单执行表明细', keepAlive: true }
  // },
  {
    /** 工单完工分析表 */
    path: '/out_prod/makein_report',
    name: 'OutProductionMakeinReport',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/MakeinReport.vue'),
    meta: { title: '工单完工分析表' }
  },
  {
    /** 工单完工分析表明细 */
    path: '/out_prod/makein_report_detail',
    name: 'OutProductionMakeinReportDetail',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/MakeinReportDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '工单完工分析表明细', keepAlive: true }
  },
  {
    /** 品质IQC进料分析 */
    path: '/out_prod/iqc_report',
    name: 'OutProductionIQCReport',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/IQCinReport.vue'),
    meta: { title: '品质IQC进料分析' }
  },
  {
    /** 品质IQC进料分析明细 */
    path: '/out_prod/iqc_report_detail',
    name: 'OutProductionIQCReportDetail',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/IQCReportDetail.vue'),
    props: (route) => ({ initData: route.params.item, querytype: route.params.querytype }),
    meta: { title: '品质IQC进料分析明细', keepAlive: true }
  },
  {
    /** F/OQC检验分析 */
    path: '/out_prod/fqc_report',
    name: 'OutProductionFQCReport',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/FQCReport.vue'),
    meta: { title: 'F/OQC检验分析' }
  },
  {
    /** F/OQC检验分析明细 */
    path: '/out_prod/fqc_report_detail',
    name: 'OutProductionFQCReportDetail',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/FQCReportDetail.vue'),
    props: (route) => ({ initData: route.params.item, querytype: route.params.querytype }),
    meta: { title: 'F/OQC检验分析明细', keepAlive: true }
  },
  {
    /** QC检验分析 */
    path: '/out_prod/qc_report',
    name: 'OutProductionQCReport',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/QCReport.vue'),
    meta: { title: 'QC检验分析' }
  },
  {
    /** 品质FOQC检验分析明细 */
    path: '/out_prod/qc_report_detail',
    name: 'OutProductionQCReportDetail',
    component: () => import(/* webpackChunkName: "out_prod" */ '../views/out_prod/QCReportDetail.vue'),
    props: (route) => ({ initData: route.params.item, querytype: route.params.querytype }),
    meta: { title: '品质QC检验分析明细', keepAlive: true }
  },
  {
    /** 拆解日报表 */
    path: '/disassemble/hour_report',
    name: 'DisassembleHourReport',
    component: () => import(/* webpackChunkName: "disassemble" */ '../views/disassemble/HourReport.vue'),
    meta: { title: '拆解日报表' }
  },
  {
    /** 拆解日报明细 */
    path: '/disassemble/hour_report_detail',
    name: 'DisassembleHourReportDetail',
    component: () => import(/* webpackChunkName: "disassemble" */ '../views/disassemble/HourReportDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '拆解日报明细', keepAlive: true }
  },
  {
    /** 拆解在制分析 */
    path: '/disassemble/inprocess_report',
    name: 'DisassembleInprocessReport',
    component: () => import(/* webpackChunkName: "disassemble" */ '../views/disassemble/InprocessReport.vue'),
    meta: { title: '拆解在制分析' }
  },
  {
    /** 拆解进度 */
    path: '/disassemble/progress_report',
    name: 'DisassembleInprocessReport',
    component: () => import(/* webpackChunkName: "disassemble" */ '../views/disassemble/ProgressReport.vue'),
    meta: { title: '拆解进度' }
  },
  {
    /** 拆解损耗 */
    path: '/disassemble/loss_report',
    name: 'DisassembleLossReport',
    component: () => import(/* webpackChunkName: "disassemble" */ '../views/disassemble/LossReport.vue'),
    meta: { title: '拆解损耗' }
  },
  {
    /** 拆解完工 */
    path: '/disassemble/in_report',
    name: 'DisassembleInReport',
    component: () => import(/* webpackChunkName: "disassemble" */ '../views/disassemble/InReport.vue'),
    meta: { title: '拆解完工' }
  },
  {
    /** 拆解完工明细 */
    path: '/disassemble/in_report_detail',
    name: 'DisassembleInReportDetail',
    component: () => import(/* webpackChunkName: "disassemble" */ '../views/disassemble/InReportDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: '拆解完工明细', keepAlive: true }
  },
  {
    /** 科目列表 */
    path: '/finance/category_list',
    name: 'FinanceCategoryList',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/CategoryList.vue'),
    meta: { title: '科目', keepAlive: true }
  },
  {
    /** 科目 */
    path: '/finance/category/:id',
    name: 'FinanceCategory',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/Category.vue'),
    meta: { title: '科目' }
  },
  {
    /** 编辑科目 */
    path: '/finance/category_edit',
    name: 'FinanceCategoryEdit',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/CategoryEdit.vue'),
    meta: { title: '编辑科目' }
  },
  {
    /** 银行账户列表 */
    path: '/finance/bank_list',
    name: 'FinanceBankList',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/BankList.vue'),
    meta: { title: '银行账户', keepAlive: true }
  },
  {
    /** 税率设置 */
    path: '/finance/tax_edit',
    name: 'FinanceTaxEdit',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/TaxEdit.vue'),
    meta: { title: '税率设置' }
  },
  {
    /** 本位币设置 */
    path: '/finance/currency_st_edit',
    name: 'FinanceCurrencyStEdit',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/CurrencyStEdit.vue'),
    meta: { title: '本位币设置' }
  },
  {
    /** 存货计价设置 */
    path: '/finance/price_type_edit',
    name: 'FinancePriceTypeEdit',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/PriceTypeEdit.vue'),
    meta: { title: '存货计价设置' }
  },
  {
    /** 业务关联科目设置 */
    path: '/finance/biz_category_list',
    name: 'FinanceBizCategoryList',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/BizCategoryList.vue'),
    meta: { title: '业务关联科目设置', keepAlive: true }
  },
  {
    /** 业务关联科目设置 */
    path: '/finance/biz_category_edit',
    name: 'FinanceBizCategoryEdit',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/BizCategoryEdit.vue'),
    meta: { title: '业务关联科目设置' }
  },
  {
    /** 收款方式设置列表 */
    path: '/finance/paymentsrec_list',
    name: 'FinancePaymentsrecList',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/PaymentsrecList.vue'),
    meta: { title: '收款方式设置', keepAlive: true }
  },
  {
    /** 编辑收款方式设置 */
    path: '/finance/paymentsrec_edit',
    name: 'FinancePaymentsrecEdit',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/PaymentsrecEdit.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '编辑收款方式' }
  },
  {
    /** 付款方式设置列表 */
    path: '/finance/paymentspay_list',
    name: 'FinancePaymentspayList',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/PaymentspayList.vue'),
    meta: { title: '付款方式设置', keepAlive: true }
  },
  {
    /** 编辑付款方式设置 */
    path: '/finance/paymentspay_edit',
    name: 'FinancePaymentspayEdit',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/PaymentspayEdit.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: '编辑付款方式' }
  },
  {
    /** 日记账列表 */
    path: '/finance/journal_list',
    name: 'FinanceJournalList',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/JournalList.vue'),
    meta: { title: '日记账', keepAlive: true }
  },
  {
    /** 日记账 */
    path: '/finance/journal/:id',
    name: 'FinanceJournal',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/Journal.vue'),
    meta: { title: '日记账' }
  },
  {
    /** 资金计划 */
    path: '/finance/fundplan',
    name: 'FinanceFundplan',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/Fundplan.vue'),
    meta: { title: '资金计划', keepAlive: true }
  },
  {
    /** 应收排程 */
    path: '/finance/receivable_schedule',
    name: 'ReceivableSchedule',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/ReceivableSchedule.vue'),
    meta: { title: '应收排程', keepAlive: true }
  },
  {
    /** 应收发票列表 */
    path: '/money/receivable_invoice_list',
    name: 'ReceivableInvoiceList',
    component: () => import(/* webpackChunkName: "finance" */ '../views/money/ReceivableInvoiceList.vue'),
    meta: { title: '应收发票', keepAlive: true }
  },
  {
    /** 应收发票 */
    path: '/money/receivable_invoice/:id',
    name: 'ReceivableInvoice',
    component: () => import(/* webpackChunkName: "finance" */ '../views/money/ReceivableInvoice.vue'),
    meta: { title: '应收发票', keepAlive: true }
  },
  {
    /** 应付排程 */
    path: '/finance/pay_schedule',
    name: 'PaySchedule',
    component: () => import(/* webpackChunkName: "finance" */ '../views/finance/PaySchedule.vue'),
    meta: { title: '应付排程', keepAlive: true }
  },
  {
    /** 应付发票列表 */
    path: '/money/pay_invoice_list',
    name: 'PayInvoiceList',
    component: () => import(/* webpackChunkName: "finance" */ '../views/money/PayInvoiceList.vue'),
    meta: { title: '应付发票', keepAlive: true }
  },
  {
    /** 应付发票 */
    path: '/money/pay_invoice/:id',
    name: 'PayInvoice',
    component: () => import(/* webpackChunkName: "finance" */ '../views/money/PayInvoice.vue'),
    meta: { title: '应付发票', keepAlive: true }
  },
  {
    /** 单据编码规则 */
    path: '/sys/code_rule_list',
    name: 'SysCodeRuleList',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/CodeRuleList.vue'),
    meta: { title: '单据编码规则', keepAlive: true }
  },
  {
    /** 单据编码规则 */
    path: '/sys/code_rule_edit',
    name: 'SysCodeRuleEdit',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/CodeRuleEdit.vue'),
    meta: { title: '单据编码规则' }
  },
  {
    /** 公司资料 */
    path: '/sys/company_edit',
    name: 'SysCompanyEdit',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/CompanyEdit.vue'),
    meta: { title: '公司资料' }
  },
  {
    /** 岗位列表 */
    path: '/sys/role_list',
    name: 'SysRoleList',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/RoleList.vue'),
    meta: { title: '岗位列表' }
  },
  {
    /** 岗位 */
    path: '/sys/role/:id',
    name: 'SysRole',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/Role.vue'),
    meta: { title: '岗位' }
  },
  {
    /** 编辑岗位 */
    path: '/sys/role_edit',
    name: 'SysRoleEdit',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/RoleEdit.vue'),
    meta: { title: '岗位' }
  },
  {
    /** 组织树 */
    path: '/sys/org/:id',
    name: 'SysOrg',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/OrgTree.vue'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: { title: '人员组织' }
  },
  {
    /** 商协通树 */
    path: '/sys/virtual_org/:id',
    name: 'SysVirtualOrg',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/VirtualOrgTree.vue'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: { title: '商协通' }
  },
  {
    /** 我的账号 */
    path: '/sys/account_edit',
    name: 'SysAccountEdit',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/AccountEdit.vue'),
    meta: { title: '我的账号' }
  },
  {
    /** 企业二维码 */
    path: '/sys/company_card',
    name: 'SysCompanyCard',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/CompanyCard.vue'),
    meta: { title: '企业二维码' }
  },
  {
    /** 邀请同事 */
    path: '/sys/invite_colleague',
    name: 'SysInviteColleague',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/InviteColleague.vue'),
    meta: { title: '邀请同事' }
  },
  {
    /** 修改密码 - 账号验证 */
    path: '/security/password',
    name: 'SecPassword',
    component: () => import(/* webpackChunkName: "sys" */ '../views/security/Password.vue'),
    meta: { title: '账号验证' }
  },
  {
    /** 通过密码验证 */
    path: '/security/reset_by_pass',
    name: 'SecResetByPass',
    component: () => import(/* webpackChunkName: "sys" */ '../views/security/ResetByPass.vue'),
    props: (route) => ({ mobile: route.query.mobile }),
    meta: { title: '修改密码' }
  },
  {
    /** 通过手机短信验证 */
    path: '/security/reset_by_mobile',
    name: 'SecResetByMobile',
    component: () => import(/* webpackChunkName: "sys" */ '../views/security/ResetByMobile.vue'),
    props: (route) => ({ mobile: route.query.mobile }),
    meta: { title: '修改密码' }
  },
  {
    /** 帮助中心 */
    path: '/help',
    name: 'Help',
    component: () => import(/* webpackChunkName: "sys" */ '../views/help/Index.vue'),
    props: (route) => ({ projectCode: route.query.projectCode }),
    meta: { title: '帮助中心', keepAlive: true }
  },
  {
    /** 帮助中心 */
    path: '/doc/project_items',
    name: 'DocProjectItems',
    component: () => import(/* webpackChunkName: "sys" */ '../views/help/ProjectItem.vue'),
    props: (route) => ({ projectCode: route.params.projectCode, projectItem: route.params.projectItem }),
    meta: { title: '帮助中心', keepAlive: true }
  },
  {
    /** 帮助中心 */
    path: '/doc/:projectCode/:itemCode',
    name: 'DocArticle',
    component: () => import(/* webpackChunkName: "sys" */ '../views/help/Article.vue'),
    props: (route) => ({ projectCode: route.params.projectCode, itemCode: route.params.itemCode }),
    meta: { title: '帮助中心' }
  },
  {
    /** 问题反馈 */
    path: '/help/feedback',
    name: 'HelpFeedback',
    component: () => import(/* webpackChunkName: "sys" */ '../views/help/Feedback.vue'),
    meta: { title: '问题反馈', keepAlive: true },
    children: [{
      path: '',
      component: () => import(/* webpackChunkName: "sys" */ '../views/help/FeedbackList.vue'),
      props: () => ({ all: true }),
      meta: { title: '问题反馈', activeTab: 'home', keepAlive: true }
    }, {
      path: 'mine',
      component: () => import(/* webpackChunkName: "sys" */ '../views/help/FeedbackList.vue'),
      props: () => ({ all: false }),
      meta: { title: '我的问题反馈', activeTab: 'mine', keepAlive: true }
    }]
  },
  {
    /** 编辑问题反馈 */
    path: '/help/feedback_edit',
    name: 'HelpFeedbackEdit',
    component: () => import(/* webpackChunkName: "sys" */ '../views/help/FeedbackEdit.vue'),
    meta: { title: '我要反馈' }
  },
  {
    /** 专属顾问 */
    path: '/partner/adviser',
    name: 'Adviser',
    component: () => import(/* webpackChunkName: "sys" */ '../views/partner/Adviser.vue'),
    meta: { title: '专属顾问' }
  },
  {
    /** 电子印章 */
    path: '/sys/seal_edit',
    name: 'SysSealEdit',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/SealEdit.vue'),
    meta: { title: '电子印章' }
  },
  {
    /** 升级说明 */
    path: '/sys/upgrade_notice/:id',
    name: 'SysUpgradeNotice',
    component: () => import(/* webpackChunkName: "sys" */ '../views/sys/UpgradeNotice.vue'),
    meta: { title: '升级说明', auth: false }
  },
  {
    /** 百度地图 */
    path: '/map/baidu',
    name: 'BaiduMap',
    component: () => import(/* webpackChunkName: "common" */ '../views/map/Baidu.vue'),
    meta: { title: '百度地图', auth: false }
  },
  {
    /** 手写签名设计 */
    path: '/sign/pad',
    name: 'SignPad',
    component: () => import(/* webpackChunkName: "common" */ '../views/sign/SignPad.vue'),
    meta: { title: '签名设计' }
  },
  {
    /** 我的签名 */
    path: '/sign/info',
    name: 'SignInfo',
    component: () => import(/* webpackChunkName: "common" */ '../views/sign/SignInfo.vue'),
    meta: { title: '我的签名' }
  },
  {
    /** 活动列表 */
    path: '/crm/activity_list',
    name: 'CrmActivityList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ActivityList.vue'),
    meta: { title: '活动', keepAlive: true }
  },
  {
    /** 活动 */
    path: '/crm/activity/:id',
    name: 'CrmActivity',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/Activity.vue'),
    meta: { title: '活动' }
  },
  {
    /** 编辑活动 */
    path: '/crm/activity_edit',
    name: 'CrmActivityEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ActivityEdit.vue'),
    meta: { title: '编辑活动' }
  },
  {
    /** 售后管理列表 */
    path: '/crm/after_sale_list',
    name: 'AfterSaleList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSaleList.vue'),
    meta: { title: '售后', keepAlive: true }
  },
  {
    /** 售后管理 */
    path: '/crm/after_sale/:id',
    name: 'AfterSale',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSale.vue'),
    meta: { title: '售后' }
  },
  {
    /** 编辑售后管理 */
    path: '/crm/after_sale_edit',
    name: 'AfterSaleEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSaleEdit.vue'),
    meta: { title: '编辑售后' }
  },
  {
    /** 售后维修列表 */
    path: '/crm/after_sale_repair_list',
    name: 'AfterSaleRepairList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSaleRepairList.vue'),
    meta: { title: '售后维修', keepAlive: true }
  },
  {
    /** 售后维修 */
    path: '/crm/after_sale_repair/:id',
    name: 'AfterSaleRepair',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSaleRepair.vue'),
    meta: { title: '售后维修' }
  },
  {
    /** 编辑售后维修 */
    path: '/crm/after_sale_repair_edit',
    name: 'AfterSaleRepairEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSaleRepairEdit.vue'),
    meta: { title: '编辑售后维修' }
  },
  {
    /** 售后领料列表 */
    path: '/crm/after_sale_pick_list',
    name: 'AfterSalePickList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSalePickList.vue'),
    meta: { title: '售后领料', keepAlive: true }
  },
  {
    /** 售后领料 */
    path: '/crm/after_sale_pick/:id',
    name: 'AfterSalePick',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSalePick.vue'),
    meta: { title: '售后领料' }
  },
  {
    /** 编辑售后领料 */
    path: '/crm/after_sale_pick_edit',
    name: 'AfterSalePickEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/AfterSalePickEdit.vue'),
    meta: { title: '编辑售后领料' }
  },
  {
    /** 服务项目列表 */
    path: '/crm/serve_item_list',
    name: 'CrmServeItemList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeItemList.vue'),
    meta: { title: '服务项目', keepAlive: true }
  },
  {
    /** 服务项目详情 */
    path: '/crm/serve_item/:id',
    name: 'CrmServeItem',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeItem.vue'),
    meta: { title: '服务项目' }
  },
  {
    /** 编辑服务项目 */
    path: '/crm/serve_item_edit',
    name: 'CrmServeItemEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeItemEdit.vue'),
    meta: { title: '编辑服务项目' }
  },
  {
    /** 服务合同列表 */
    path: '/crm/serve_contract_list',
    name: 'CrmServeContractList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeContractList.vue'),
    meta: { title: '服务合同', keepAlive: true }
  },
  {
    /** 服务合同详情 */
    path: '/crm/serve_contract/:id',
    name: 'CrmServeContract',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeContract.vue'),
    meta: { title: '服务合同' }
  },
  {
    /** 编辑服务合同 */
    path: '/crm/serve_contract_edit',
    name: 'CrmServeContractEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeContractEdit.vue'),
    meta: { title: '编辑服务合同' }
  },
  {
    /** 收费单列表 */
    path: '/crm/serve_fee_list',
    name: 'CrmServeFeeList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeFeeList.vue'),
    meta: { title: '收费单', keepAlive: true }
  },
  {
    /** 收费单详情 */
    path: '/crm/serve_fee/:id',
    name: 'CrmServeFee',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeFee.vue'),
    meta: { title: '收费单' }
  },
  {
    /** 编辑收费单 */
    path: '/crm/serve_fee_edit',
    name: 'CrmServeFeeEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ServeFeeEdit.vue'),
    meta: { title: '编辑收费单' }
  },
  {
    /** 活动 */
    path: '/crm/activity_qrcode/:id',
    name: 'CrmActivityQrCode',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ActivityQrCode.vue'),
    meta: { title: '活动签到' }
  },
  {
    /** 客户拜访列表 */
    path: '/crm/client_visit_list',
    name: 'CrmClientVisitList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ClientVisitList.vue'),
    meta: { title: '客户拜访', keepAlive: true }
  },
  {
    /** 客户拜访 */
    path: '/crm/client_visit/:id',
    name: 'CrmClientVisit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ClientVisit.vue'),
    meta: { title: '客户拜访' }
  },
  {
    /** 编辑客户拜访 */
    path: '/crm/client_visit_edit',
    name: 'CrmClientVisitEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/ClientVisitEdit.vue'),
    meta: { title: '编辑客户拜访' }
  },
  {
    /** 商机管理 */
    path: '/crm/business',
    name: 'CrmBusiness',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/Business.vue'),
    meta: { title: '商机管理', keepAlive: true }
  },
  {
    /** 商机管理详情 */
    path: '/crm/business_detail',
    name: 'CrmBusinessDetail',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/BusinessDetail.vue'),
    props: (route) => ({ item: route.params.item }),
    meta: { title: '商机管理详情' }
  },
  {
    /** 转化率分析详情 */
    path: '/crm/business_zhl_detail',
    name: 'CrmBusinessZHLDetail',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/BusinessZHLDetail.vue'),
    props: (route) => ({ item: route.params.item }),
    meta: { title: '转化率分析详情' }
  },
  {
    /** 活动签到（嘉宾使用） */
    path: '/open/crm/activity/sign_edit',
    name: 'OpenActivitySignEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/OpenActivitySignEdit.vue'),
    meta: { title: '活动签到', auth: false }
  },
  {
    /** 活动签到（嘉宾使用） */
    path: '/open/crm/activity/sign',
    name: 'OpenActivitySign',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/OpenActivitySign.vue'),
    meta: { title: '活动签到', auth: false }
  },
  {
    /** 活动签到（嘉宾使用） */
    path: '/open/crm/activity/sign_list',
    name: 'OpenActivitySignList',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/OpenActivitySignList.vue'),
    meta: { title: '活动签到', auth: false }
  },
  {
    /** 活动报名（嘉宾使用） */
    path: '/open/crm/activity/signup_edit',
    name: 'OpenActivitySignupEdit',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/OpenActivitySignupEdit.vue'),
    meta: { title: '活动报名', auth: false }
  },
  {
    /** 活动报名（嘉宾使用） */
    path: '/open/crm/activity/signup',
    name: 'OpenActivitySignup',
    component: () => import(/* webpackChunkName: "crm" */ '../views/crm/OpenActivitySignup.vue'),
    meta: { title: '活动报名', auth: false }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('../views/common/Gallery.vue'),
    meta: { title: '图片展示', auth: false }
  },
  {
    /** App下载 */
    path: '/app_portal',
    name: 'AppPortal',
    component: () => import(/* webpackChunkName: "app" */ '../views/app/Portal.vue'),
    meta: { title: '华商云服APP下载', auth: false }
  },
  {
    /** 借h5跳转APP端 */
    path: '/launch/app',
    name: 'LaunchApp',
    component: () => import(/* webpackChunkName: "app" */ '../views/app/Launch.vue'),
    meta: { title: '华商云服APP', auth: false }
  },


  {
    /** b2b客户采购订单列表 */
    path: '/b2b/purchase_list',
    name: 'B2BPurchaseList',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/PurchaseList.vue'),
    meta: { title: 'b2b客户采购订单', keepAlive: true }
  },
  {
    /** b2b客户采购订单 */
    path: '/b2b/purchase_order',
    name: 'B2BPurchaseOrder',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/PurchaseOrder.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b客户采购订单' }
  },
  {
    /** b2b客户采购订单变更 */
    path: '/b2b/purchase_change',
    name: 'B2BPurchaseChange',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/PurchaseChange.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b客户采购订单变更' }
  },
  {
    /** b2b采购订单取消 */
    path: '/b2b/purchase_cancel',
    name: 'B2BPurchaseCancel',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/PurchaseCancel.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b采购订单取消' }
  },
  {
    /** b2b采购订单退货 */
    path: '/b2b/purchase_return',
    name: 'B2BPurchaseReturn',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/PurchaseReturn.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b采购订单退货' }
  },
  {
    /** b2b客户外协订单列表 */
    path: '/b2b/os_make_list',
    name: 'B2BOsMakeList',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/OsMakeList.vue'),
    meta: { title: 'b2b客户外协订单', keepAlive: true }
  },
  {
    /** b2b客户外协订单 */
    path: '/b2b/os_make_order',
    name: 'B2BOsMakeOrder',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/OsMakeOrder.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b客户外协订单' }
  },
  {
    /** b2b外协订单变更 */
    path: '/b2b/os_make_change',
    name: 'B2BOsMakeChange',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/OsMakeChange.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b外协订单变更' }
  },
  {
    /** b2b外协订单取消 */
    path: '/b2b/os_make_cancel',
    name: 'B2BOsMakeCancel',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/OsMakeCancel.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b外协订单取消' }
  },
  {
    /** b2b外协订单退货 */
    path: '/b2b/os_make_return',
    name: 'B2BOsMakeReturn',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/OsMakeReturn.vue'),
    props: (route) => ({ initData: route.params.initData }),
    meta: { title: 'b2b外协订单退货' }
  },
  {
    /** b2b送货单 */
    path: '/b2b/out/:id',
    name: 'B2BOut',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/Out.vue'),
    meta: { title: 'b2b送货单' }
  },

  {
    /** b2b对账单列表 */
    path: '/b2b/customer_bill_list',
    name: 'B2BCustomerBillList',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/CustomerBillList.vue'),
    meta: { title: 'b2b对账单列表', keepAlive: true }
  },
  {
    /** b2b对账单详细列表 */
    path: '/b2b/customer_bill_detail_list',
    name: 'B2BCustomerBillDetailList',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/CustomerBillDetailList.vue'),
    meta: { title: 'b2b对账单详细列表', keepAlive: true }
  },
  {
    /** b2b对账单详细 */
    path: '/b2b/customer_bill_detail',
    name: 'B2BCustomerBillDetail',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/CustomerBillDetail.vue'),
    props: (route) => ({ initData: route.params.item }),
    meta: { title: 'b2b对账单详细列表', keepAlive: true }
  },

  {
    /** b2b应收发票列表 */
    path: '/b2b/bill_list',
    name: 'B2BBillList',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/BillList.vue'),
    meta: { title: 'b2b客户外协订单', keepAlive: true }
  },
  {
    /** b2b应收发票 */
    path: '/b2b/bill/:id',
    name: 'B2BBill',
    component: () => import(/* webpackChunkName: "b2b" */ '../views/b2b/Bill.vue'),
    meta: { title: 'b2b应收发票' }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const meta = to.meta;
  if (meta && meta.title) {
    document.title = meta.title;
  }
  // 默认需要验证登录，配置auth: false的无需验证
  // 企业微信入口的无需验证
  if (meta && meta.auth !== false && !Weixin.isWxWork()) {
    if (!Session.valid()) {
      next({
        path: '/login'
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
/**
 * uniapp环境，页面回退问题
 */
router.back = function () {
  if (window.uni) {
    window.uni.postMessage({
      data: {
        action: "back",
        params: window.location.pathname + decodeURIComponent(window.location.search)
      }
    });
  } else {
    router.go(-1);
  }
}

export default router
